'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('@reduxjs/toolkit/query/react');
var query = require('@reduxjs/toolkit/query');
var react$1 = require('react');
var msgPack = require('msgpack-lite');
var toolkit = require('@reduxjs/toolkit');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var msgPack__default = /*#__PURE__*/_interopDefaultLegacy(msgPack);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var configuration = {
    baseUrl: null,
    token: null,
};
var getBaseUrl = function () { return configuration.baseUrl; };
var getToken = function () { return configuration.token; };
/**
 * Set the baseUrl and auth token.
 */
var setApiConfig = function (baseUrl, token) {
    configuration.baseUrl = baseUrl;
    configuration.token = token;
};
var rawBaseQuery = function (baseUrl) { return react.fetchBaseQuery({
    baseUrl: "".concat(baseUrl, "/api/v1.1"),
    prepareHeaders: function (headers) {
        var token = getToken();
        headers.set('Authorization', "Bearer ".concat(token));
        return headers;
    },
}); };
var dynamicBaseQuery = function (args, api, extraOptions) { return __awaiter(void 0, void 0, void 0, function () {
    var baseUrl;
    return __generator(this, function (_a) {
        baseUrl = getBaseUrl();
        if (!baseUrl) {
            return [2 /*return*/, {
                    error: {
                        status: 400,
                        statusText: 'Bad Request',
                        data: 'No baseUrl provided to Redux ToolKit Query',
                    },
                }];
        }
        return [2 /*return*/, rawBaseQuery(baseUrl)(args, api, extraOptions)];
    });
}); };
var emptyOpenmoticsApi = react.createApi({
    reducerPath: 'api',
    tagTypes: [
        'Output',
        'ThermostatUnit',
        'ThermostatGroup',
        'Shutter',
        'DashboardItem',
        'Notification',
        'User',
        'Role',
        'EventRule',
        'Installation',
        'Gateway',
        'Application',
        'ApplicationGrant',
        'Settings',
        'PluginConfig',
        'EnergyTariffs',
    ],
    baseQuery: dynamicBaseQuery,
    endpoints: function () { return ({}); },
});

var ThermostatState;
(function (ThermostatState) {
    ThermostatState["On"] = "ON";
    ThermostatState["Off"] = "OFF";
})(ThermostatState || (ThermostatState = {}));
var ThermostatMode;
(function (ThermostatMode) {
    ThermostatMode["Heating"] = "HEATING";
    ThermostatMode["Cooling"] = "COOLING";
})(ThermostatMode || (ThermostatMode = {}));
var ThermostatCapabilities;
(function (ThermostatCapabilities) {
    ThermostatCapabilities["Heating"] = "HEATING";
    ThermostatCapabilities["Cooling"] = "COOLING";
    ThermostatCapabilities["OnOff"] = "ON_OFF";
    ThermostatCapabilities["OutsideSensorOnOff"] = "OUTSIDE_SENSOR_ON_OFF";
    ThermostatCapabilities["Manual"] = "MANUAL";
})(ThermostatCapabilities || (ThermostatCapabilities = {}));
var ThermostatPreset;
(function (ThermostatPreset) {
    ThermostatPreset["Auto"] = "AUTO";
    ThermostatPreset["Away"] = "AWAY";
    ThermostatPreset["Manual"] = "MANUAL";
    ThermostatPreset["Override"] = "OVERRIDE";
})(ThermostatPreset || (ThermostatPreset = {}));

var capitalizeFirstLetter = function (str, index) {
    var res = str.slice();
    if (index === 0) {
        return res;
    }
    return res.charAt(0).toUpperCase() + res.slice(1);
};
var prepareResponseObject = function (data) {
    if (Array.isArray(data)) {
        return data.map(function (item) { return prepareResponseObject(item); });
    }
    if (data === null) {
        return null;
    }
    if (typeof data === 'object') {
        var resultObject_1 = {};
        Object.keys(data || {}).forEach(function (key) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                var keyParts = key.startsWith('_')
                    ? key.replace(/_/gi, '')
                    : key.split('_').map(capitalizeFirstLetter).join('');
                resultObject_1[keyParts] = prepareResponseObject(data[key]);
            }
        });
        return resultObject_1;
    }
    return data;
};
var camelToSnakeCase = function (str) { return str.replace(/[A-Z]/g, function (letter) { return "_".concat(letter.toLowerCase()); }); };
var prepareRequestPayloadObject = function (data) {
    if (Array.isArray(data)) {
        return data.map(function (item) { return prepareRequestPayloadObject(item); });
    }
    if (data === null) {
        return null;
    }
    if (typeof data === 'object') {
        var resultObject_2 = {};
        Object.keys(data || {}).forEach(function (key) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                var keyParts = camelToSnakeCase(key);
                resultObject_2[keyParts] = prepareRequestPayloadObject(data[key]);
            }
        });
        return resultObject_2;
    }
    return data;
};
function throttle(cb, delay) {
    var shouldWait = false;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (shouldWait)
            return;
        // eslint-disable-next-line prefer-spread
        cb.apply(null, args);
        shouldWait = true;
        setTimeout(function () {
            shouldWait = false;
        }, delay);
    };
}
function useCallbackOnScreenResize(callback, delay) {
    if (delay === void 0) { delay = 100; }
    react$1.useEffect(function () {
        window.addEventListener('resize', throttle(callback, delay));
        return function () {
            window.removeEventListener('resize', throttle(callback, delay));
        };
        // eslint-disable-next-line
    }, []);
}

/*
 * Copyright (C) 2020 OpenMotics BV
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var ImageSize;
(function (ImageSize) {
    ImageSize["Small"] = "SMALL";
    ImageSize["Medium"] = "MEDIUM";
    ImageSize["Original"] = "ORIGINAL";
})(ImageSize || (ImageSize = {}));

var GatewayModel;
(function (GatewayModel) {
    GatewayModel["OPENMOTICS"] = "openmotics";
    GatewayModel["SENSE"] = "sense";
    GatewayModel["HEALTHBOX3"] = "healthbox3";
})(GatewayModel || (GatewayModel = {}));
var InstallationType;
(function (InstallationType) {
    InstallationType["private"] = "PRIVATE";
    InstallationType["common"] = "COMMON";
})(InstallationType || (InstallationType = {}));

var GroupActionUsage;
(function (GroupActionUsage) {
    GroupActionUsage["Scene"] = "SCENE";
})(GroupActionUsage || (GroupActionUsage = {}));

var UpdateStatus;
(function (UpdateStatus) {
    UpdateStatus["DONE"] = "DONE";
    UpdateStatus["FAILED"] = "FAILED";
    UpdateStatus["IN_PROGRESS"] = "IN_PROGRESS";
    UpdateStatus["SCHEDULED"] = "SCHEDULED";
    UpdateStatus["QUEUED"] = "QUEUED";
    UpdateStatus["ABORTED"] = "ABORTED";
})(UpdateStatus || (UpdateStatus = {}));

var ConsumptionType;
(function (ConsumptionType) {
    ConsumptionType["Electricity"] = "ELECTRICITY";
    ConsumptionType["Energy"] = "ENERGY";
    ConsumptionType["Gas"] = "GAS";
    ConsumptionType["Heat"] = "HEAT";
    ConsumptionType["Water"] = "WATER";
})(ConsumptionType || (ConsumptionType = {}));
var LabelType;
(function (LabelType) {
    LabelType["Grid"] = "GRID";
    LabelType["Solar"] = "SOLAR";
    LabelType["Battery"] = "BATTERY";
    LabelType["Wind"] = "WIND";
    LabelType["Custom"] = "CUSTOM";
})(LabelType || (LabelType = {}));
var ConsumptionResolution;
(function (ConsumptionResolution) {
    ConsumptionResolution["Month"] = "M";
    ConsumptionResolution["Day"] = "D";
    ConsumptionResolution["FourHours"] = "4h";
    ConsumptionResolution["Hour"] = "h";
    ConsumptionResolution["Quarter"] = "15m";
    ConsumptionResolution["FiveMinutes"] = "5m";
    ConsumptionResolution["Minute"] = "1m";
})(ConsumptionResolution || (ConsumptionResolution = {}));

var OpenmoticsDeliveryType;
(function (OpenmoticsDeliveryType) {
    OpenmoticsDeliveryType["DELIVERY"] = "DELIVERY";
    OpenmoticsDeliveryType["RETURN"] = "RETURN";
})(OpenmoticsDeliveryType || (OpenmoticsDeliveryType = {}));

var OpenmoticsUserRole;
(function (OpenmoticsUserRole) {
    OpenmoticsUserRole["SUPER"] = "SUPER";
    OpenmoticsUserRole["ADMIN"] = "ADMIN";
    OpenmoticsUserRole["USER"] = "USER";
    OpenmoticsUserRole["COURIER"] = "COURIER";
    OpenmoticsUserRole["TECHNICIAN"] = "TECHNICIAN";
})(OpenmoticsUserRole || (OpenmoticsUserRole = {}));
var OpenmoticsUserLanguages;
(function (OpenmoticsUserLanguages) {
    OpenmoticsUserLanguages["ENGLISH"] = "English";
    OpenmoticsUserLanguages["DEUTSCH"] = "Deutsch";
    OpenmoticsUserLanguages["NEDERLANDS"] = "Nederlands";
    OpenmoticsUserLanguages["FRANCAIS"] = "Francais";
})(OpenmoticsUserLanguages || (OpenmoticsUserLanguages = {}));

var PhysicalQuantity;
(function (PhysicalQuantity) {
    PhysicalQuantity["Temperature"] = "temperature";
    PhysicalQuantity["Humidity"] = "humidity";
    PhysicalQuantity["CO2"] = "co2";
    PhysicalQuantity["VOC"] = "voc";
    PhysicalQuantity["Dust"] = "dust";
    PhysicalQuantity["Sound"] = "sound";
    PhysicalQuantity["Brightness"] = "brightness";
    PhysicalQuantity["Power"] = "power";
    PhysicalQuantity["ElectricCurrent"] = "electric_current";
    PhysicalQuantity["ElectricPotential"] = "electric_potential";
    PhysicalQuantity["Energy"] = "energy";
    PhysicalQuantity["Frequency"] = "frequency";
})(PhysicalQuantity || (PhysicalQuantity = {}));

var ShutterState;
(function (ShutterState) {
    ShutterState["Up"] = "UP";
    ShutterState["GoingUp"] = "GOING_UP";
    ShutterState["Down"] = "DOWN";
    ShutterState["GoingDown"] = "GOING_DOWN";
    ShutterState["Stopped"] = "STOPPED";
})(ShutterState || (ShutterState = {}));
var ShutterDirections;
(function (ShutterDirections) {
    ShutterDirections["up"] = "UP";
    ShutterDirections["down"] = "DOWN";
    ShutterDirections["stopped"] = "STOP";
})(ShutterDirections || (ShutterDirections = {}));
var LockType;
(function (LockType) {
    LockType["Local"] = "LOCAL_LOCK";
    LockType["Cloud"] = "CLOUD_LOCK";
})(LockType || (LockType = {}));

// eslint-disable-next-line
var VentilationMode;
(function (VentilationMode) {
    VentilationMode["Automatic"] = "auto";
    VentilationMode["Manual"] = "manual";
})(VentilationMode || (VentilationMode = {}));

var SocketDataType;
(function (SocketDataType) {
    SocketDataType["OutputChange"] = "OUTPUT_CHANGE";
    SocketDataType["ShutterChange"] = "SHUTTER_CHANGE";
    SocketDataType["ThermostatChange"] = "THERMOSTAT_CHANGE";
    SocketDataType["ThermostatGroupChange"] = "THERMOSTAT_GROUP_CHANGE";
    SocketDataType["InputTrigger"] = "INPUT_TRIGGER";
    SocketDataType["VentilationChange"] = "VENTILATION_CHANGE";
    SocketDataType["HotWaterChange"] = "HOT_WATER_CHANGE";
    SocketDataType["InsightRealtime"] = "INSIGHT_REALTIME";
})(SocketDataType || (SocketDataType = {}));

var TriggerTypeEnum;
(function (TriggerTypeEnum) {
    TriggerTypeEnum["INPUT"] = "input";
    TriggerTypeEnum["OUTPUT"] = "output";
})(TriggerTypeEnum || (TriggerTypeEnum = {}));
var TriggerStatusEnum;
(function (TriggerStatusEnum) {
    TriggerStatusEnum["ON"] = "activate";
    TriggerStatusEnum["OFF"] = "deactivate";
    TriggerStatusEnum["CHANGE"] = "change";
})(TriggerStatusEnum || (TriggerStatusEnum = {}));

var UserRoleEnum;
(function (UserRoleEnum) {
    UserRoleEnum["Admin"] = "Admin";
    UserRoleEnum["User"] = "User";
})(UserRoleEnum || (UserRoleEnum = {}));

var BackupStatus;
(function (BackupStatus) {
    BackupStatus["DONE"] = "DONE";
    BackupStatus["FAILED"] = "FAILED";
    BackupStatus["IN_PROGRESS"] = "IN_PROGRESS";
})(BackupStatus || (BackupStatus = {}));

var DataType;
(function (DataType) {
    DataType["SOLAR"] = "solar";
    DataType["GRID"] = "grid";
    DataType["HOME"] = "home";
    DataType["BATTERY"] = "battery";
    DataType["CAR"] = "car";
    DataType["HEATPUMP"] = "heatpump";
})(DataType || (DataType = {}));

var PresetAction;
(function (PresetAction) {
    PresetAction[PresetAction["Today"] = 0] = "Today";
    PresetAction[PresetAction["Last7Days"] = 1] = "Last7Days";
    PresetAction[PresetAction["Last31Days"] = 2] = "Last31Days";
    PresetAction[PresetAction["CurrentWeek"] = 3] = "CurrentWeek";
    PresetAction[PresetAction["CurrentMonth"] = 4] = "CurrentMonth";
})(PresetAction || (PresetAction = {}));

var defaultSocketTypes = [
    SocketDataType.OutputChange,
    SocketDataType.ShutterChange,
    SocketDataType.ThermostatChange,
    SocketDataType.ThermostatGroupChange,
    SocketDataType.InputTrigger,
    SocketDataType.VentilationChange,
    SocketDataType.HotWaterChange,
];
var Websocket = /** @class */ (function () {
    function Websocket(url, options, types) {
        if (types === void 0) { types = defaultSocketTypes; }
        var _this = this;
        this.SECONDS_PING = 30;
        this.tick = this.SECONDS_PING;
        this.timer = null;
        this.socket = null;
        this.installationIds = null;
        this.isOpened = false;
        this.types = [];
        this.reconnectAttempts = 0;
        this.connectionPromise = null;
        // eslint-disable-next-line
        this.connect = function (installationIds) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.socket && this.socket.readyState !== WebSocket.CLOSED) {
                    return [2 /*return*/, this.connectionPromise];
                }
                if (!this.connectionPromise) {
                    this.connectionPromise = new Promise(function (resolve, reject) {
                        var token = getToken();
                        var replacedToken = btoa(token).replace(/=/g, '');
                        var ws = new WebSocket(_this.url, ["authorization.bearer.".concat(replacedToken)]);
                        ws.binaryType = 'arraybuffer';
                        ws.onopen = function () {
                            _this.socket = ws;
                            _this.socket.onmessage = _this.onMessage;
                            _this.startTimer();
                            _this.subscribe(installationIds);
                            resolve(_this);
                            _this.isOpened = true;
                            _this.reconnectAttempts = 0;
                        };
                        ws.onerror = function (err) {
                            console.log('WS error:', err);
                            _this.onError(err);
                            // eslint-disable-next-line prefer-promise-reject-errors
                            reject(_this);
                        };
                        ws.onclose = function (ev) {
                            console.log('Websocket closed trying to reconnect...');
                            _this.connectionPromise = null;
                            _this.tryReconnect(installationIds);
                        };
                    });
                }
                return [2 /*return*/, this.connectionPromise];
            });
        }); };
        this.tryReconnect = function (installationIds) {
            var interval = 3000;
            if (_this.reconnectAttempts > 5) {
                interval = 1000 * 60 * 5; // 5 minutes
            }
            _this.reconnectAttempts += 1;
            setTimeout(function () {
                _this.connect(installationIds);
            }, interval);
        };
        this.addOnMessageListener = function (listener) {
            var _a;
            (_a = _this.options) === null || _a === void 0 ? void 0 : _a.onMessage.push(listener);
        };
        this.onMessage = function (event) {
            _this.tick = _this.SECONDS_PING;
            if (_this.options) {
                var decoded_1 = msgPack__default["default"].decode(new Uint8Array(event.data));
                _this.options.onMessage.forEach(function (listener) { return listener(decoded_1); });
            }
        };
        this.onError = function (error) {
            if (_this.options) {
                _this.options.onError(error);
            }
        };
        this.send = function (data) {
            _this.socket.send(msgPack__default["default"].encode(data));
        };
        this.startTimer = function () {
            _this.timer = setInterval(function () {
                _this.tick -= 1;
                if (_this.tick === 0) {
                    _this.send({ type: 'PING', data: null });
                    setTimeout(function () {
                        if (_this.tick < 0) {
                            clearInterval(_this.timer);
                        }
                    }, _this.SECONDS_PING * 1000);
                }
            }, 1000);
        };
        this.subscribe = function (installationIds) {
            if (!_this.socket) {
                return;
            }
            _this.send({
                type: 'ACTION',
                data: {
                    action: 'set_subscription',
                    types: _this.types,
                    installation_ids: installationIds,
                },
            });
        };
        this.close = function () {
            if (_this.socket && _this.isOpened) {
                _this.socket.close();
                clearTimeout(_this.timer);
                _this.isOpened = false;
            }
        };
        this.options = options;
        this.url = url.replace('http', 'ws');
        this.types = types;
    }
    return Websocket;
}());

var websocket = null;
/**
 * Creates a websocket if it doesn't exist yet.
 */
var getWebsocket = function (installationId, onMessage) { return __awaiter(void 0, void 0, void 0, function () {
    var url, options;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (websocket
                    && ((_a = websocket.installationIds) === null || _a === void 0 ? void 0 : _a.length)
                    && websocket.installationIds[0] !== installationId) {
                    websocket.close(); // Close the socket, because there is no way unsubscribe from the previous installation.
                    websocket = null;
                }
                if (!(websocket === null)) return [3 /*break*/, 2];
                url = "".concat(getBaseUrl(), "/api/v1.1/ws/events");
                options = {
                    onError: function (e) {
                        console.log(e);
                        // reconnect ws
                        if (websocket && websocket.installationIds) {
                            websocket.close();
                            websocket.connect(websocket.installationIds);
                        }
                    },
                    onMessage: [onMessage],
                    onClose: function () {
                        console.log('Websocket closed');
                        websocket = null;
                    },
                };
                websocket = new Websocket(url, options);
                websocket.installationIds = [installationId];
                return [4 /*yield*/, websocket.connect([installationId])];
            case 1:
                _b.sent();
                return [3 /*break*/, 3];
            case 2:
                websocket.addOnMessageListener(onMessage);
                _b.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); };

var extendedApi$q = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getThermostatUnits: builder.query({
            query: function (_a) {
                var installationId = _a.installationId;
                return "/base/installations/".concat(installationId, "/thermostats/units");
            },
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            providesTags: function (result) { return (result
                ? __spreadArray(__spreadArray([], result.map(function (_a) {
                    var id = _a.id;
                    return ({ type: 'ThermostatUnit', id: id });
                }), true), [
                    { type: 'ThermostatUnit', id: 'LIST' },
                ], false) : [{ type: 'ThermostatUnit', id: 'LIST' }]); },
            onCacheEntryAdded: function (arg, _a) {
                var updateCachedData = _a.updateCachedData, cacheDataLoaded = _a.cacheDataLoaded, cacheEntryRemoved = _a.cacheEntryRemoved;
                return __awaiter(this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                try {
                                    getWebsocket(arg.installationId, function (event) { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!(event.type === SocketDataType.ThermostatChange)) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, cacheDataLoaded];
                                                case 1:
                                                    _a.sent();
                                                    updateCachedData(function (draft) {
                                                        var unit = draft.find(function (a) { return a.id === event.data.id; });
                                                        var nextStatus = prepareResponseObject(event.data.status);
                                                        var nextState = nextStatus.state, nextSetpoint = nextStatus.currentSetpoint;
                                                        if (unit) {
                                                            unit.status = __assign(__assign(__assign({}, unit.status), nextStatus), { currentSetpoint: nextState === ThermostatState.On ? nextSetpoint : null });
                                                        }
                                                    });
                                                    _a.label = 2;
                                                case 2: return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                }
                                catch ( /* empty */_c) { /* empty */ }
                                return [4 /*yield*/, cacheEntryRemoved];
                            case 1:
                                _b.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
        }),
        getThermostatUnit: builder.query({
            query: function (_a) {
                var installationId = _a.installationId, thermostatId = _a.thermostatId;
                return "/base/installations/".concat(installationId, "/thermostats/units/").concat(thermostatId);
            },
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            providesTags: function (result, error, _a) {
                var thermostatId = _a.thermostatId;
                return [{ type: 'ThermostatUnit', id: thermostatId }];
            },
            onCacheEntryAdded: function (arg, _a) {
                var updateCachedData = _a.updateCachedData, cacheDataLoaded = _a.cacheDataLoaded, cacheEntryRemoved = _a.cacheEntryRemoved;
                return __awaiter(this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                try {
                                    getWebsocket(arg.installationId, function (event) { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!(event.type === SocketDataType.ThermostatChange)) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, cacheDataLoaded];
                                                case 1:
                                                    _a.sent();
                                                    updateCachedData(function (draft) {
                                                        var unit = draft;
                                                        var nextStatus = prepareResponseObject(event.data.status);
                                                        if (unit && unit.id === event.data.id) { // Only update incoming events for this thermostat.
                                                            unit.status = __assign(__assign({}, unit.status), nextStatus);
                                                        }
                                                    });
                                                    _a.label = 2;
                                                case 2: return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                }
                                catch ( /* empty */_c) { /* empty */ }
                                return [4 /*yield*/, cacheEntryRemoved];
                            case 1:
                                _b.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
        }),
        getThermostatUnitSchedule: builder.query({
            query: function (_a) {
                var installationId = _a.installationId, unitId = _a.unitId;
                return "/base/installations/".concat(installationId, "/thermostats/units/").concat(unitId, "/schedule");
            },
            transformResponse: function (response) { return prepareResponseObject(response.data); },
        }),
        setThermostatUnitSchedule: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, unitId = _a.unitId, schedule = _a.schedule;
                return ({
                    url: "/base/installations/".concat(installationId, "/thermostats/units/").concat(unitId, "/schedule"),
                    method: 'POST',
                    body: schedule,
                });
            },
        }),
        getThermostatGroups: builder.query({
            query: function (_a) {
                var installationId = _a.installationId;
                return "/base/installations/".concat(installationId, "/thermostats/groups");
            },
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            providesTags: function (result) { return (result
                ? __spreadArray(__spreadArray([], result.map(function (_a) {
                    var id = _a.id;
                    return ({ type: 'ThermostatGroup', id: id });
                }), true), [
                    { type: 'ThermostatGroup', id: 'LIST' },
                ], false) : [{ type: 'ThermostatGroup', id: 'LIST' }]); },
            onCacheEntryAdded: function (arg, _a) {
                var updateCachedData = _a.updateCachedData, cacheDataLoaded = _a.cacheDataLoaded, cacheEntryRemoved = _a.cacheEntryRemoved;
                return __awaiter(this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                try {
                                    getWebsocket(arg.installationId, function (event) { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!(event.type === SocketDataType.ThermostatGroupChange)) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, cacheDataLoaded];
                                                case 1:
                                                    _a.sent();
                                                    updateCachedData(function (draft) {
                                                        var group = draft.find(function (a) { return a.id === event.data.id; });
                                                        if (group) {
                                                            group.status = __assign(__assign({}, group.status), prepareResponseObject(event.data.status));
                                                        }
                                                    });
                                                    _a.label = 2;
                                                case 2: return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                }
                                catch ( /* empty */_c) { /* empty */ }
                                return [4 /*yield*/, cacheEntryRemoved];
                            case 1:
                                _b.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
        }),
        setGroupMode: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, groupId = _a.groupId, mode = _a.mode;
                return ({
                    url: "/base/installations/".concat(installationId, "/thermostats/groups/").concat(groupId, "/mode"),
                    method: 'POST',
                    body: { mode: mode },
                });
            },
        }),
        setGroupPreset: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, groupId = _a.groupId, preset = _a.preset;
                return ({
                    url: "/base/installations/".concat(installationId, "/thermostats/groups/").concat(groupId, "/preset"),
                    method: 'POST',
                    body: { preset: preset },
                });
            },
        }),
        setGroupState: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, groupId = _a.groupId, state = _a.state;
                return ({
                    url: "/base/installations/".concat(installationId, "/thermostats/groups/").concat(groupId, "/state"),
                    method: 'POST',
                    body: { state: state },
                });
            },
        }),
        setGlobalMode: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, mode = _a.mode;
                return ({
                    url: "/base/installations/".concat(installationId, "/thermostats/mode"),
                    method: 'POST',
                    body: { mode: mode },
                });
            },
        }),
        setGlobalPreset: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, preset = _a.preset;
                return ({
                    url: "/base/installations/".concat(installationId, "/thermostats/preset"),
                    method: 'POST',
                    body: { preset: preset },
                });
            },
        }),
        setGlobalState: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, state = _a.state;
                return ({
                    url: "/base/installations/".concat(installationId, "/thermostats/state"),
                    method: 'POST',
                    body: { state: state },
                });
            },
        }),
        setUnitSetpoint: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, unitId = _a.unitId, temperature = _a.temperature, expiration = _a.expiration;
                return ({
                    url: "/base/installations/".concat(installationId, "/thermostats/units/").concat(unitId, "/setpoint"),
                    method: 'POST',
                    body: { temperature: temperature, preset_expiration: expiration },
                });
            },
        }),
        setUnitState: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, unitId = _a.unitId, state = _a.state;
                return ({
                    url: "/base/installations/".concat(installationId, "/thermostats/units/").concat(unitId, "/state"),
                    method: 'POST',
                    body: { state: state },
                });
            },
        }),
        setUnitPreset: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, unitId = _a.unitId, preset = _a.preset;
                return ({
                    url: "/base/installations/".concat(installationId, "/thermostats/units/").concat(unitId, "/preset"),
                    method: 'POST',
                    body: { preset: preset },
                });
            },
        }),
        setUnitPresetNew: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, unitId = _a.unitId, preset = _a.preset, expiration = _a.expiration;
                return ({
                    url: "/base/installations/".concat(installationId, "/thermostats/units/").concat(unitId, "/preset"),
                    method: 'POST',
                    body: { preset: preset, preset_expiration: expiration },
                });
            },
        }),
        setUnitPresetConfig: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, unitId = _a.unitId, heating = _a.heating, cooling = _a.cooling;
                return ({
                    url: "/base/installations/".concat(installationId, "/thermostats/units/").concat(unitId, "/preset/config"),
                    method: 'POST',
                    body: { away_heating: heating, away_cooling: cooling },
                });
            },
            invalidatesTags: function (res, err, _a) {
                var unitId = _a.unitId;
                return [{ type: 'ThermostatUnit', id: unitId }];
            },
        }),
        setUnitEarlyStarts: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, unitId = _a.unitId, body = _a.body;
                return ({
                    url: "/base/installations/".concat(installationId, "/thermostats/units/").concat(unitId, "/early-start"),
                    method: 'POST',
                    body: prepareRequestPayloadObject(body),
                });
            },
            invalidatesTags: function (res, err, _a) {
                var unitId = _a.unitId;
                return [{ type: 'ThermostatUnit', id: unitId }];
            },
        }),
    }); },
});
var useGetThermostatUnitsQuery = extendedApi$q.useGetThermostatUnitsQuery, useGetThermostatUnitQuery = extendedApi$q.useGetThermostatUnitQuery, useGetThermostatGroupsQuery = extendedApi$q.useGetThermostatGroupsQuery, useGetThermostatUnitScheduleQuery = extendedApi$q.useGetThermostatUnitScheduleQuery, useSetGroupModeMutation = extendedApi$q.useSetGroupModeMutation, useSetGroupPresetMutation = extendedApi$q.useSetGroupPresetMutation, useSetGroupStateMutation = extendedApi$q.useSetGroupStateMutation, useSetGlobalModeMutation = extendedApi$q.useSetGlobalModeMutation, useSetGlobalPresetMutation = extendedApi$q.useSetGlobalPresetMutation, useSetGlobalStateMutation = extendedApi$q.useSetGlobalStateMutation, useSetUnitSetpointMutation = extendedApi$q.useSetUnitSetpointMutation, useSetUnitStateMutation = extendedApi$q.useSetUnitStateMutation, useSetUnitPresetMutation = extendedApi$q.useSetUnitPresetMutation, useSetUnitPresetNewMutation = extendedApi$q.useSetUnitPresetNewMutation, useSetUnitPresetConfigMutation = extendedApi$q.useSetUnitPresetConfigMutation, useSetThermostatUnitScheduleMutation = extendedApi$q.useSetThermostatUnitScheduleMutation, useSetUnitEarlyStartsMutation = extendedApi$q.useSetUnitEarlyStartsMutation;

var extendedApi$p = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getShutters: builder.query({
            query: function (_a) {
                var installationId = _a.installationId;
                return "/base/installations/".concat(installationId, "/shutters?filter={\"usage\":\"CONTROL\"}");
            },
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            providesTags: function (result) { return (result
                ? __spreadArray(__spreadArray([], result.map(function (_a) {
                    var id = _a.id;
                    return ({ type: 'Shutter', id: id });
                }), true), [
                    { type: 'Shutter', id: 'LIST' },
                ], false) : [{ type: 'Shutter', id: 'LIST' }]); },
            onCacheEntryAdded: function (arg, _a) {
                var updateCachedData = _a.updateCachedData, cacheDataLoaded = _a.cacheDataLoaded, cacheEntryRemoved = _a.cacheEntryRemoved;
                return __awaiter(this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                try {
                                    getWebsocket(arg.installationId, function (event) { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!(event.type === SocketDataType.ShutterChange)) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, cacheDataLoaded];
                                                case 1:
                                                    _a.sent();
                                                    updateCachedData(function (draft) {
                                                        var shutter = draft.find(function (a) { return a.id === event.data.id; });
                                                        if (shutter) {
                                                            shutter.status = __assign(__assign({}, shutter.status), event.data.status);
                                                        }
                                                    });
                                                    _a.label = 2;
                                                case 2: return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                }
                                catch (_c) {
                                    // no-op in case `cacheEntryRemoved` resolves before `cacheDataLoaded`,
                                    // in which case `cacheDataLoaded` will throw
                                }
                                // cacheEntryRemoved will resolve when the cache subscription is no longer active
                                return [4 /*yield*/, cacheEntryRemoved];
                            case 1:
                                // cacheEntryRemoved will resolve when the cache subscription is no longer active
                                _b.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
        }),
        setShutterMotion: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, id = _a.id, toState = _a.toState;
                var motionSuffix = toState;
                return {
                    url: "/base/installations/".concat(installationId, "/shutters/").concat(id, "/").concat(motionSuffix),
                    method: 'POST',
                };
            },
        }),
        setShutterPosition: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, id = _a.id, position = _a.position;
                return ({
                    url: "/base/installations/".concat(installationId, "/shutters/").concat(id, "/change_position"),
                    method: 'POST',
                    body: {
                        position: position,
                    },
                });
            },
        }),
        setShutterRotation: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, id = _a.id, position = _a.position;
                return ({
                    url: "/base/installations/".concat(installationId, "/shutters/").concat(id, "/rotate"),
                    method: 'POST',
                    body: {
                        value: position,
                    },
                });
            },
        }),
        setShutterLocation: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, id = _a.id, floorId = _a.floorId, x = _a.x, y = _a.y;
                return ({
                    url: "/base/installations/".concat(installationId, "/shutters/").concat(id, "/location"),
                    method: 'POST',
                    body: {
                        floor_coordinates: { x: x, y: y },
                        floor_id: floorId,
                    },
                });
            },
            onQueryStarted: function (_a, _b) {
                var id = _a.id, installationId = _a.installationId, patch = __rest(_a, ["id", "installationId"]);
                var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled;
                return __awaiter(this, void 0, void 0, function () {
                    var patchResult;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                patchResult = dispatch(extendedApi$p.util.updateQueryData('getShutters', { installationId: installationId }, function (draft) {
                                    var shutter = draft.find(function (a) { return a.id === id; });
                                    shutter.location.floorCoordinates.x = patch.x;
                                    shutter.location.floorCoordinates.y = patch.y;
                                    shutter.location.floorId = patch.floorId;
                                }));
                                _d.label = 1;
                            case 1:
                                _d.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, queryFulfilled];
                            case 2:
                                _d.sent();
                                return [3 /*break*/, 4];
                            case 3:
                                _d.sent();
                                patchResult.undo();
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            },
            invalidatesTags: function (result, error, _a) {
                var id = _a.id;
                return [{ type: 'Shutter', id: id }];
            },
        }),
    }); },
});
var useGetShuttersQuery = extendedApi$p.useGetShuttersQuery, useSetShutterMotionMutation = extendedApi$p.useSetShutterMotionMutation, useSetShutterLocationMutation = extendedApi$p.useSetShutterLocationMutation, useSetShutterPositionMutation = extendedApi$p.useSetShutterPositionMutation, useSetShutterRotationMutation = extendedApi$p.useSetShutterRotationMutation;

var extendedApi$o = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getRooms: builder.query({
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            query: function (_a) {
                var installationId = _a.installationId;
                return "/base/installations/".concat(installationId, "/rooms?filter={\"size\":\"MEDIUM\"}");
            }, // could pass as param.
        }),
        getRoom: builder.query({
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            query: function (_a) {
                var installationId = _a.installationId, roomId = _a.roomId;
                return "/base/installations/".concat(installationId, "/rooms/").concat(roomId, "?filter={\"size\":\"MEDIUM\"}");
            }, // could pass as param.
        }),
        addRoom: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, name = _a.name, floorId = _a.floorId;
                return ({
                    url: "/base/installations/".concat(installationId, "/rooms"),
                    method: 'POST',
                    body: { name: name, floor_id: floorId },
                });
            },
        }),
        updateRoom: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, name = _a.name, roomId = _a.roomId, floorId = _a.floorId;
                return ({
                    url: "/base/installations/".concat(installationId, "/rooms/").concat(roomId),
                    method: 'PUT',
                    body: { name: name, id: roomId, floor_id: floorId },
                });
            },
        }),
        removeRoom: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, roomId = _a.roomId;
                return ({
                    url: "/base/installations/".concat(installationId, "/rooms/").concat(roomId),
                    method: 'DELETE',
                });
            },
        }),
        uploadRoomImage: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, roomId = _a.roomId, image = _a.image;
                var matchedExtension = image.name.match(/[0-9a-z]+$/i);
                var imageExtension = matchedExtension && (matchedExtension === null || matchedExtension === void 0 ? void 0 : matchedExtension.length) > 0 ? matchedExtension[0] : null;
                return {
                    url: "/base/installations/".concat(installationId, "/rooms/").concat(roomId, "/picture"),
                    method: 'POST',
                    body: image,
                    headers: {
                        'Content-Disposition': "attachment; filename=\"".concat(image.name, "\""),
                        'Content-Type': "image/".concat(imageExtension),
                    },
                };
            },
        }),
        deleteRoomImage: builder.mutation({
            query: function (_a) {
                var roomId = _a.roomId, installationId = _a.installationId;
                return ({
                    url: "/base/installations/".concat(installationId, "/rooms/").concat(roomId, "/picture"),
                    method: 'DELETE',
                });
            },
        }),
    }); },
});
var useGetRoomsQuery = extendedApi$o.useGetRoomsQuery, useGetRoomQuery = extendedApi$o.useGetRoomQuery, useUpdateRoomMutation = extendedApi$o.useUpdateRoomMutation, useUploadRoomImageMutation = extendedApi$o.useUploadRoomImageMutation, useAddRoomMutation = extendedApi$o.useAddRoomMutation, useRemoveRoomMutation = extendedApi$o.useRemoveRoomMutation, useDeleteRoomImageMutation = extendedApi$o.useDeleteRoomImageMutation;

var extendedApi$n = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getVentilationUnits: builder.query({
            transformResponse: function (response, meta, arg) { return prepareResponseObject(response.data); },
            query: function (_a) {
                var installationId = _a.installationId;
                return "/base/installations/".concat(installationId, "/ventilations/units");
            },
            onCacheEntryAdded: function (arg, _a) {
                var updateCachedData = _a.updateCachedData, cacheDataLoaded = _a.cacheDataLoaded, cacheEntryRemoved = _a.cacheEntryRemoved;
                return __awaiter(this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                try {
                                    getWebsocket(arg.installationId, function (event) { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!(event.type === SocketDataType.VentilationChange)) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, cacheDataLoaded];
                                                case 1:
                                                    _a.sent();
                                                    updateCachedData(function (draft) {
                                                        var unit = draft.find(function (a) { return a.id === event.data.id; });
                                                        var nextStatus = prepareResponseObject(event.data.status);
                                                        if (unit) {
                                                            unit.status = __assign(__assign({}, unit.status), nextStatus);
                                                        }
                                                    });
                                                    _a.label = 2;
                                                case 2: return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                }
                                catch ( /* empty */_c) { /* empty */ }
                                return [4 /*yield*/, cacheEntryRemoved];
                            case 1:
                                _b.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
        }),
        setVentilationUnitLevel: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, unitId = _a.unitId, levelPayload = _a.levelPayload;
                return ({
                    url: "/base/installations/".concat(installationId, "/ventilations/units/").concat(unitId, "/level"),
                    method: 'POST',
                    body: levelPayload,
                });
            },
        }),
        setVentilationUnitMode: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, unitId = _a.unitId;
                return ({
                    url: "/base/installations/".concat(installationId, "/ventilations/units/").concat(unitId, "/auto"),
                    method: 'POST',
                });
            },
        }),
        boostVentilationUnit: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, unitId = _a.unitId, timer = _a.timer;
                return ({
                    url: "/base/installations/".concat(installationId, "/ventilations/units/").concat(unitId, "/boost"),
                    method: 'POST',
                    body: { timer: timer },
                });
            },
        }),
    }); },
});
var useGetVentilationUnitsQuery = extendedApi$n.useGetVentilationUnitsQuery, useSetVentilationUnitLevelMutation = extendedApi$n.useSetVentilationUnitLevelMutation, useSetVentilationUnitModeMutation = extendedApi$n.useSetVentilationUnitModeMutation, useBoostVentilationUnitMutation = extendedApi$n.useBoostVentilationUnitMutation;

var extendedApi$m = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getScenes: builder.query({
            query: function (_a) {
                var installationId = _a.installationId, nonFiltered = _a.nonFiltered;
                return "/base/installations/".concat(installationId, "/groupactions").concat(nonFiltered ? '' : '?filter={"usage":"SCENE"}');
            },
            transformResponse: function (response, meta, arg) { return prepareResponseObject(response.data); },
        }),
        triggerGroupAction: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, id = _a.id;
                return ({
                    url: "/base/installations/".concat(installationId, "/groupactions/").concat(id, "/trigger"),
                    method: 'POST',
                });
            },
        }),
    }); },
});
var useGetScenesQuery = extendedApi$m.useGetScenesQuery, useTriggerGroupActionMutation = extendedApi$m.useTriggerGroupActionMutation;

var extendedApi$l = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getOutputs: builder.query({
            query: function (_a) {
                var installationId = _a.installationId;
                return "/base/installations/".concat(installationId, "/outputs?filter={\"usage\":\"CONTROL\"}");
            },
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            providesTags: function (result) { return (result
                ? __spreadArray(__spreadArray([], result.map(function (_a) {
                    var id = _a.id;
                    return ({ type: 'Output', id: id });
                }), true), [
                    { type: 'Output', id: 'LIST' },
                ], false) : [{ type: 'Output', id: 'LIST' }]); },
            onCacheEntryAdded: function (arg, _a) {
                var updateCachedData = _a.updateCachedData, cacheDataLoaded = _a.cacheDataLoaded, cacheEntryRemoved = _a.cacheEntryRemoved;
                return __awaiter(this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                try {
                                    getWebsocket(arg.installationId, function (event) { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!(event.type === SocketDataType.OutputChange)) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, cacheDataLoaded];
                                                case 1:
                                                    _a.sent();
                                                    updateCachedData(function (draft) {
                                                        var output = draft.find(function (a) { return a.id === event.data.id; });
                                                        if (output) {
                                                            output.status = __assign(__assign({}, output.status), event.data.status);
                                                        }
                                                    });
                                                    _a.label = 2;
                                                case 2: return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                }
                                catch (_c) {
                                    // no-op in case `cacheEntryRemoved` resolves before `cacheDataLoaded`,
                                    // in which case `cacheDataLoaded` will throw
                                }
                                // cacheEntryRemoved will resolve when the cache subscription is no longer active
                                return [4 /*yield*/, cacheEntryRemoved];
                            case 1:
                                // cacheEntryRemoved will resolve when the cache subscription is no longer active
                                _b.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
        }),
        getOutput: builder.query({
            query: function (_a) {
                var installationId = _a.installationId, id = _a.id;
                return "/base/installations/".concat(installationId, "/outputs/").concat(id);
            },
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            providesTags: function (result, error, _a) {
                var id = _a.id;
                return [{ type: 'Output', id: id }];
            },
        }),
        updateLight: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, id = _a.id, toState = _a.toState, value = _a.value;
                var stateSuffix = toState ? 'turn_on' : 'turn_off';
                return {
                    url: "/base/installations/".concat(installationId, "/outputs/").concat(id, "/").concat(stateSuffix),
                    method: 'POST',
                    body: toState && (value || value === 0) ? { value: value } : {},
                };
            },
            // websocket will handle this.
            // invalidatesTags: (result, error, { id }) => [{ type: 'Output', id }],
        }),
        setOutputLocation: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, id = _a.id, floorId = _a.floorId, x = _a.x, y = _a.y;
                return ({
                    url: "/base/installations/".concat(installationId, "/outputs/").concat(id, "/location"),
                    method: 'POST',
                    body: {
                        floor_coordinates: { x: x, y: y },
                        floor_id: floorId,
                    },
                });
            },
            onQueryStarted: function (_a, _b) {
                var id = _a.id, installationId = _a.installationId, patch = __rest(_a, ["id", "installationId"]);
                var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled;
                return __awaiter(this, void 0, void 0, function () {
                    var patchResult;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                patchResult = dispatch(extendedApi$l.util.updateQueryData('getOutputs', { installationId: installationId }, function (draft) {
                                    var output = draft.find(function (a) { return a.id === id; });
                                    output.location.floorCoordinates.x = patch.x;
                                    output.location.floorCoordinates.y = patch.y;
                                    output.location.floorId = patch.floorId;
                                }));
                                _d.label = 1;
                            case 1:
                                _d.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, queryFulfilled];
                            case 2:
                                _d.sent();
                                return [3 /*break*/, 4];
                            case 3:
                                _d.sent();
                                patchResult.undo();
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            },
            invalidatesTags: function (result, error, _a) {
                var id = _a.id;
                return [{ type: 'Output', id: id }];
            },
        }),
        turnOffOutputs: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, outputFilter = _a.outputFilter;
                return ({
                    url: "/base/installations/".concat(installationId, "/outputs/turn_off"),
                    method: 'POST',
                    body: outputFilter || {},
                });
            },
            invalidatesTags: function () { return [{ type: 'Output', id: 'LIST' }]; },
        }),
    }); },
});
var useGetOutputsQuery = extendedApi$l.useGetOutputsQuery, useGetOutputQuery = extendedApi$l.useGetOutputQuery, useUpdateLightMutation = extendedApi$l.useUpdateLightMutation, useTurnOffOutputsMutation = extendedApi$l.useTurnOffOutputsMutation, useSetOutputLocationMutation = extendedApi$l.useSetOutputLocationMutation;

var extendedApi$k = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getHotWaterList: builder.query({
            query: function (installationId) { return "/base/installations/".concat(installationId, "/hotwater"); },
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            onCacheEntryAdded: function (installationId, _a) {
                var updateCachedData = _a.updateCachedData, cacheDataLoaded = _a.cacheDataLoaded, cacheEntryRemoved = _a.cacheEntryRemoved;
                return __awaiter(this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                try {
                                    getWebsocket(installationId, function (event) { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!(event.type === SocketDataType.HotWaterChange)) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, cacheDataLoaded];
                                                case 1:
                                                    _a.sent();
                                                    updateCachedData(function (draft) {
                                                        var hotWater = draft.find(function (a) { return a.id === event.data.id; });
                                                        if (hotWater) {
                                                            hotWater.status = __assign(__assign({}, hotWater.status), prepareResponseObject(event.data.status));
                                                        }
                                                    });
                                                    _a.label = 2;
                                                case 2: return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                }
                                catch (_c) {
                                    // no-op in case `cacheEntryRemoved` resolves before `cacheDataLoaded`,
                                    // in which case `cacheDataLoaded` will throw
                                }
                                // cacheEntryRemoved will resolve when the cache subscription is no longer active
                                return [4 /*yield*/, cacheEntryRemoved];
                            case 1:
                                // cacheEntryRemoved will resolve when the cache subscription is no longer active
                                _b.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
        }),
        setHotWaterState: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, hotWaterId = _a.hotWaterId, payload = _a.payload;
                return ({
                    url: "/base/installations/".concat(installationId, "/hotwater/").concat(hotWaterId, "/state"),
                    method: 'POST',
                    body: payload,
                });
            },
        }),
        setHotWaterSetpoint: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, hotWaterId = _a.hotWaterId, payload = _a.payload;
                return ({
                    url: "/base/installations/".concat(installationId, "/hotwater/").concat(hotWaterId, "/setpoint"),
                    method: 'POST',
                    body: payload,
                });
            },
        }),
    }); },
});
var useGetHotWaterListQuery = extendedApi$k.useGetHotWaterListQuery, useSetHotWaterStateMutation = extendedApi$k.useSetHotWaterStateMutation, useSetHotWaterSetpointMutation = extendedApi$k.useSetHotWaterSetpointMutation;

/**
 * Loads all controls from openmotics with RTK Queries.
 * @param installationId
 */
var useAllControls = function (installationId) {
    var thermostatUnits = useGetThermostatUnitsQuery(installationId ? { installationId: installationId } : query.skipToken, {
        selectFromResult: function (_a) {
            var data = _a.data, isLoading = _a.isLoading, rest = __rest(_a, ["data", "isLoading"]);
            return (__assign({ data: (data === null || data === void 0 ? void 0 : data.filter(function (unit) { return !['', 'NOT_IN_USE', undefined].includes(unit.name); })) || [], isLoading: isLoading }, rest));
        },
    });
    var thermostatGroups = useGetThermostatGroupsQuery(installationId ? { installationId: installationId } : query.skipToken, {
        selectFromResult: function (_a) {
            var data = _a.data, isLoading = _a.isLoading, rest = __rest(_a, ["data", "isLoading"]);
            return (__assign({ data: (data === null || data === void 0 ? void 0 : data.filter(function (group) { return group.thermostatIds.length; })) || [], isLoading: isLoading }, rest));
        },
    });
    var shutters = useGetShuttersQuery(installationId ? { installationId: installationId } : query.skipToken);
    var rooms = useGetRoomsQuery(installationId ? { installationId: installationId } : query.skipToken);
    var ventilationUnits = useGetVentilationUnitsQuery(installationId ? { installationId: installationId } : query.skipToken);
    var scenes = useGetScenesQuery(installationId ? { installationId: installationId } : query.skipToken);
    var hotWaterList = useGetHotWaterListQuery(installationId !== null && installationId !== void 0 ? installationId : query.skipToken);
    var outputs = useGetOutputsQuery(installationId ? { installationId: installationId } : query.skipToken, {
        selectFromResult: function (_a) {
            var data = _a.data, isLoading = _a.isLoading, rest = __rest(_a, ["data", "isLoading"]);
            return (__assign({ lights: (data === null || data === void 0 ? void 0 : data.filter(function (output) { return output.type === 'LIGHT'; })) || [], outlets: (data === null || data === void 0 ? void 0 : data.filter(function (output) { return output.type === 'OUTLET'; })) || [], heaters: (data === null || data === void 0 ? void 0 : data.filter(function (output) { return output.type === 'HEATER'; })) || [], isLoading: isLoading }, rest));
        },
    });
    var isLoading = thermostatUnits.isLoading || thermostatGroups.isLoading || shutters.isLoading
        || rooms.isLoading || ventilationUnits.isLoading || scenes.isLoading || outputs.isLoading || hotWaterList.isLoading;
    var refetch = function () {
        thermostatUnits.refetch();
        thermostatGroups.refetch();
        shutters.refetch();
        rooms.refetch();
        ventilationUnits.refetch();
        scenes.refetch();
        outputs.refetch();
        hotWaterList.refetch();
    };
    return {
        thermostatGroups: thermostatGroups,
        thermostatUnits: thermostatUnits,
        shutters: shutters,
        rooms: rooms,
        ventilationUnits: ventilationUnits,
        scenes: scenes,
        outputs: outputs,
        hotWaterList: hotWaterList,
        isLoading: isLoading,
        refetch: refetch,
    };
};

var extendedApi$j = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        login: builder.mutation({
            transformResponse: function (response) { return prepareResponseObject(response); },
            query: function (authenticationData) { return ({
                url: '/authentication/basic/login',
                method: 'POST',
                body: authenticationData,
            }); },
        }),
        initResetPasswordFlow: builder.mutation({
            query: function (email) { return ({
                url: '/authentication/password/init_reset',
                method: 'POST',
                body: { email: email },
            }); },
        }),
        resetPassword: builder.mutation({
            transformResponse: function (response) { return prepareResponseObject(response); },
            query: function (resetPasswordData) { return ({
                url: '/authentication/password/reset',
                method: 'POST',
                body: prepareRequestPayloadObject(resetPasswordData),
            }); },
        }),
    }); },
});
var useLoginMutation = extendedApi$j.useLoginMutation, useInitResetPasswordFlowMutation = extendedApi$j.useInitResetPasswordFlowMutation, useResetPasswordMutation = extendedApi$j.useResetPasswordMutation;

var extendedApi$i = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getEventRules: builder.query({
            query: function (_a) {
                var installationId = _a.installationId;
                return "/base/installations/".concat(installationId, "/event-rules");
            },
            transformResponse: function (response, meta, arg) { return prepareResponseObject(response.data); },
            providesTags: function (result) { return (result
                ? __spreadArray(__spreadArray([], result.map(function (_a) {
                    var id = _a.id, title = _a.title;
                    return ({ type: 'EventRule', id: id || title });
                }), true), [
                    { type: 'EventRule', id: 'LIST' },
                ], false) : [{ type: 'EventRule', id: 'LIST' }]); },
        }),
        setEventRule: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, eventRulePayload = _a.eventRulePayload;
                return ({
                    url: "/base/installations/".concat(installationId, "/event-rules"),
                    method: 'POST',
                    body: prepareRequestPayloadObject(eventRulePayload),
                });
            },
            invalidatesTags: ['EventRule'],
        }),
        deleteEventRule: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, id = _a.id;
                return ({
                    url: "/base/installations/".concat(installationId, "/event-rules/").concat(id),
                    method: 'DELETE',
                });
            },
            invalidatesTags: ['EventRule'],
        }),
        updateEventRule: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, eventRuleId = _a.eventRuleId, eventRulePayload = _a.eventRulePayload;
                return ({
                    url: "/base/installations/".concat(installationId, "/event-rules/").concat(eventRuleId),
                    method: 'PUT',
                    body: prepareRequestPayloadObject(eventRulePayload),
                });
            },
            invalidatesTags: function (res, err, _a) {
                var eventRuleId = _a.eventRuleId;
                return [{ type: 'EventRule', id: eventRuleId }];
            },
        }),
    }); },
});
var useGetEventRulesQuery = extendedApi$i.useGetEventRulesQuery, useSetEventRuleMutation = extendedApi$i.useSetEventRuleMutation, useDeleteEventRuleMutation = extendedApi$i.useDeleteEventRuleMutation, useUpdateEventRuleMutation = extendedApi$i.useUpdateEventRuleMutation;

var extendedApi$h = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getDashboardControls: builder.query({
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            query: function (_a) {
                var installationId = _a.installationId;
                return "/base/installations/".concat(installationId, "/dashboard");
            },
            providesTags: function (result) { return (result
                ? __spreadArray(__spreadArray([], result.items.map(function (_a) {
                    var assetId = _a.assetId;
                    return ({ type: 'DashboardItem', id: assetId });
                }), true), [
                    { type: 'DashboardItem', id: 'LIST' },
                ], false) : [{ type: 'DashboardItem', id: 'LIST' }]); },
        }),
        saveDashboardControls: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, items = _a.items;
                return ({
                    url: "/base/installations/".concat(installationId, "/dashboard"),
                    method: 'POST',
                    body: {
                        items: prepareRequestPayloadObject(items),
                    },
                });
            },
            invalidatesTags: function () { return [{ type: 'DashboardItem', id: 'LIST' }]; },
        }),
        deleteDashboardControls: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, items = _a.items;
                return ({
                    url: "/base/installations/".concat(installationId, "/dashboard"),
                    method: 'DELETE',
                    body: {
                        items: prepareRequestPayloadObject(items),
                    },
                });
            },
            invalidatesTags: function () { return [{ type: 'DashboardItem', id: 'LIST' }]; },
        }),
    }); },
});
var useGetDashboardControlsQuery = extendedApi$h.useGetDashboardControlsQuery, useSaveDashboardControlsMutation = extendedApi$h.useSaveDashboardControlsMutation, useDeleteDashboardControlsMutation = extendedApi$h.useDeleteDashboardControlsMutation;

var extendedApi$g = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getFloors: builder.query({
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            query: function (_a) {
                var installationId = _a.installationId;
                return "/base/installations/".concat(installationId, "/floors?filter={\"size\":\"ORIGINAL\"}");
            }, // could pass as param.
        }),
        addFloor: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, name = _a.name, sequence = _a.sequence;
                return ({
                    url: "/base/installations/".concat(installationId, "/floors"),
                    method: 'POST',
                    body: { name: name, sequence: sequence },
                });
            },
        }),
        updateFloor: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, floorId = _a.floorId, payload = _a.payload;
                return ({
                    url: "/base/installations/".concat(installationId, "/floors/").concat(floorId),
                    method: 'PUT',
                    body: payload,
                });
            },
        }),
        deleteFloor: builder.mutation({
            query: function (_a) {
                var floorId = _a.floorId, installationId = _a.installationId;
                return ({
                    url: "/base/installations/".concat(installationId, "/floors/").concat(floorId),
                    method: 'DELETE',
                });
            },
        }),
        uploadFloorImage: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, floorId = _a.floorId, image = _a.image;
                var matchedExtension = image.name.match(/[0-9a-z]+$/i);
                var imageExtension = matchedExtension && (matchedExtension === null || matchedExtension === void 0 ? void 0 : matchedExtension.length) > 0 ? matchedExtension[0] : null;
                return {
                    url: "/base/installations/".concat(installationId, "/floors/").concat(floorId, "/picture"),
                    method: 'POST',
                    body: image,
                    headers: {
                        'Content-Disposition': "attachment; filename=\"".concat(image.name, "\""),
                        'Content-Type': "image/".concat(imageExtension),
                    },
                };
            },
        }),
        deleteFloorImage: builder.mutation({
            query: function (_a) {
                var floorId = _a.floorId, installationId = _a.installationId;
                return ({
                    url: "/base/installations/".concat(installationId, "/floors/").concat(floorId, "/picture"),
                    method: 'DELETE',
                });
            },
        }),
    }); },
});
var useGetFloorsQuery = extendedApi$g.useGetFloorsQuery, useAddFloorMutation = extendedApi$g.useAddFloorMutation, useUpdateFloorMutation = extendedApi$g.useUpdateFloorMutation, useDeleteFloorMutation = extendedApi$g.useDeleteFloorMutation, useUploadFloorImageMutation = extendedApi$g.useUploadFloorImageMutation, useDeleteFloorImageMutation = extendedApi$g.useDeleteFloorImageMutation;

var extendedApi$f = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getOpenmoticsGateways: builder.query({
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            query: function (installationId) { return "/base/installations/".concat(installationId, "/gateways/openmotics"); },
            providesTags: function (result) { return (result
                ? __spreadArray(__spreadArray([], result.map(function (_a) {
                    var id = _a.id;
                    return ({ type: 'Gateway', id: id });
                }), true), [
                    { type: 'Gateway', id: 'LIST' },
                ], false) : [{ type: 'Gateway', id: 'LIST' }]); },
        }),
        updateGatewayName: builder.mutation({
            query: function (_a) {
                var id = _a.id, name = _a.name, installationId = _a.installationId;
                return ({
                    url: "/base/installations/".concat(installationId, "/gateways/").concat(id),
                    method: 'PUT',
                    body: {
                        name: name,
                    },
                });
            },
            invalidatesTags: function () { return [{ type: 'Gateway', id: 'LIST' }]; },
        }),
        getGateways: builder.query({
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            query: function (installationId) { return "/base/installations/".concat(installationId, "/gateways"); },
        }),
    }); },
});
var useGetOpenmoticsGatewaysQuery = extendedApi$f.useGetOpenmoticsGatewaysQuery, useUpdateGatewayNameMutation = extendedApi$f.useUpdateGatewayNameMutation, useGetGatewaysQuery = extendedApi$f.useGetGatewaysQuery;

var extendedApi$e = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        addInstallation: builder.mutation({
            query: function (_a) {
                var registrationKey = _a.registrationKey, gatewayType = _a.gatewayType;
                return ({
                    url: '/base/installations',
                    method: 'POST',
                    body: {
                        registration_key: registrationKey,
                        gateway_type: gatewayType,
                    },
                });
            },
        }),
        getInstallations: builder.query({
            transformResponse: function (response, meta, arg) { return prepareResponseObject(response.data); },
            query: function () { return '/base/installations'; },
            providesTags: function (result) { return (result
                ? __spreadArray(__spreadArray([], result.map(function (_a) {
                    var id = _a.id;
                    return ({ type: 'Installation', id: id });
                }), true), [
                    { type: 'Installation', id: 'LIST' },
                ], false) : [{ type: 'Installation', id: 'LIST' }]); },
        }),
        updateInstallation: builder.mutation({
            query: function (_a) {
                var id = _a.id, payload = _a.payload;
                return ({
                    url: "/base/installations/".concat(id),
                    method: 'PUT',
                    body: __assign({}, payload),
                });
            },
            invalidatesTags: function () { return [{ type: 'Installation', id: 'LIST' }]; },
        }),
        getInstallation: builder.query({
            query: function (installationId) { return "/base/installations/".concat(installationId); },
            transformResponse: function (response) { return prepareResponseObject(response.data); },
        }),
        searchInstallations: builder.query({
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            query: function (_a) {
                var query = _a.query;
                return "/base/installations/search?query=".concat(query);
            },
        }),
        getResetGatewayConfirmationCode: builder.query({
            query: function (_a) {
                var installationId = _a.installationId, gatewayId = _a.gatewayId;
                return ({
                    url: "/base/installations/".concat(installationId, "/gateways/openmotics/").concat(gatewayId, "/factory_reset"),
                    method: 'POST',
                });
            },
            transformResponse: function (response) {
                return prepareResponseObject(response.data);
            },
        }),
        getInstallationSettings: builder.query({
            query: function (_a) {
                var installationId = _a.installationId;
                return ({
                    url: "/base/installations/".concat(installationId, "/settings"),
                    method: 'GET',
                });
            },
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            providesTags: function () { return [{ type: 'Settings', id: 'OBJECT' }]; },
        }),
        resetGateway: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, gatewayId = _a.gatewayId, factoryReset = _a.factoryReset, confirmationCode = _a.confirmationCode;
                return ({
                    url: "/base/installations/".concat(installationId, "/gateways/openmotics/").concat(gatewayId, "/factory_reset"),
                    method: 'POST',
                    body: prepareRequestPayloadObject({
                        factoryReset: factoryReset,
                        confirmationCode: confirmationCode,
                    }),
                });
            },
        }),
    }); },
});
var useGetInstallationsQuery = extendedApi$e.useGetInstallationsQuery, useGetInstallationQuery = extendedApi$e.useGetInstallationQuery, useSearchInstallationsQuery = extendedApi$e.useSearchInstallationsQuery, useAddInstallationMutation = extendedApi$e.useAddInstallationMutation, useGetResetGatewayConfirmationCodeQuery = extendedApi$e.useGetResetGatewayConfirmationCodeQuery, useResetGatewayMutation = extendedApi$e.useResetGatewayMutation, useUpdateInstallationMutation = extendedApi$e.useUpdateInstallationMutation, useGetInstallationSettingsQuery = extendedApi$e.useGetInstallationSettingsQuery;

var extendedApi$d = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getLabels: builder.query({
            query: function (_a) {
                var installationId = _a.installationId, labelsFilter = _a.labelsFilter;
                return "/base/installations/".concat(installationId, "/metrics/labels?filter=").concat(JSON.stringify(labelsFilter));
            },
            transformResponse: function (response) { return prepareResponseObject(response.data); },
        }),
        getLabel: builder.query({
            query: function (_a) {
                var installationId = _a.installationId, labelId = _a.labelId;
                return "/base/installations/".concat(installationId, "/metrics/labels/").concat(labelId);
            },
            transformResponse: function (response) { return prepareResponseObject(response.data); },
        }),
        getLabelHistorical: builder.query({
            query: function (_a) {
                var installationId = _a.installationId, labelId = _a.labelId, start = _a.start, end = _a.end, resolution = _a.resolution, _b = _a.delta, delta = _b === void 0 ? false : _b;
                return "/base/installations/".concat(installationId, "/metrics/labels/").concat(labelId, "/historical?start=").concat(start, "&end=").concat(end, "&resolution=").concat(resolution, "&delta=").concat(delta);
            },
            transformResponse: function (response) { return prepareResponseObject(response.data); },
        }),
        getCsvMetrics: builder.query({
            query: function (_a) {
                var installationId = _a.installationId, start = _a.start, end = _a.end, _b = _a.resolution, resolution = _b === void 0 ? 'D' : _b, _c = _a.delta, delta = _c === void 0 ? true : _c;
                return ({
                    url: "base/installations/".concat(installationId, "/metrics/labels/historical?start=").concat(start, "&end=").concat(end, "&resolution=").concat(resolution, "&delta=").concat(delta),
                    method: 'GET',
                    headers: { Accept: 'text/csv' },
                    responseHandler: function (response) { return response.text(); },
                });
            },
        }),
    }); },
});
var useGetLabelsQuery = extendedApi$d.useGetLabelsQuery, useGetLabelHistoricalQuery = extendedApi$d.useGetLabelHistoricalQuery, useGetLabelQuery = extendedApi$d.useGetLabelQuery, useLazyGetCsvMetricsQuery = extendedApi$d.useLazyGetCsvMetricsQuery;

var extendedApi$c = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getNotifications: builder.query({
            query: function (_a) {
                var installationId = _a.installationId;
                return "/base/notifications?filter={\"include_read\": true, \"installation_id\":".concat(installationId, "}");
            },
            transformResponse: function (response, meta, arg) { return prepareResponseObject(response.data); },
            providesTags: function (result) { return (result ? __spreadArray(__spreadArray([], result.map(function (_a) {
                var id = _a.id;
                return ({ type: 'Notification', id: id });
            }), true), [{ type: 'Notification', id: 'LIST' }], false) : [{ type: 'Notification', id: 'LIST' }]); },
        }),
        setReadNotifications: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId;
                return ({
                    url: "/base/notifications/mark_read?filter={\"installation_id\":".concat(installationId, "}"),
                    method: 'POST',
                    body: {},
                });
            },
            invalidatesTags: function () { return [{ type: 'Notification', id: 'LIST' }]; },
        }),
    }); },
});
var useGetNotificationsQuery = extendedApi$c.useGetNotificationsQuery, useSetReadNotificationsMutation = extendedApi$c.useSetReadNotificationsMutation;

var extendedApi$b = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        register: builder.mutation({
            transformResponse: function (response) { return prepareResponseObject(response); },
            query: function (registrationPayload) { return ({
                url: '/base/registration',
                method: 'POST',
                body: prepareRequestPayloadObject(registrationPayload),
            }); },
        }),
    }); },
});
var useRegisterMutation = extendedApi$b.useRegisterMutation;

var extendedApi$a = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getSensors: builder.query({
            query: function (installationId) { return "/base/installations/".concat(installationId, "/sensors"); },
            transformResponse: function (response) { return prepareResponseObject(response.data); },
        }),
    }); },
});
var useGetSensorsQuery = extendedApi$a.useGetSensorsQuery;

var extendedApi$9 = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getCurrentUser: builder.query({
            transformResponse: function (response, meta, arg) {
                return prepareResponseObject(response.data.user);
            },
            query: function () { return '/'; },
        }),
        getCurrentUserInfo: builder.query({
            query: function () { return '/base/users'; },
            transformResponse: function (response) { return prepareResponseObject(response.data)[0]; },
        }),
        setCurrentUserInfo: builder.mutation({
            query: function (_a) {
                var userId = _a.userId, userPayload = _a.userPayload;
                return ({
                    url: "/base/users/".concat(userId),
                    method: 'PUT',
                    body: prepareRequestPayloadObject(userPayload),
                });
            },
        }),
        setCurrentUserTfa: builder.mutation({
            query: function (_a) {
                var userId = _a.userId, userTfaPayload = _a.userTfaPayload;
                return ({
                    url: "/base/users/".concat(userId, "/tfa"),
                    method: 'POST',
                    body: userTfaPayload,
                });
            },
        }),
    }); },
});
var useGetCurrentUserQuery = extendedApi$9.useGetCurrentUserQuery, useGetCurrentUserInfoQuery = extendedApi$9.useGetCurrentUserInfoQuery, useSetCurrentUserInfoMutation = extendedApi$9.useSetCurrentUserInfoMutation, useSetCurrentUserTfaMutation = extendedApi$9.useSetCurrentUserTfaMutation;

var extendedApi$8 = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getInputs: builder.query({
            query: function (_a) {
                var installationId = _a.installationId;
                return "/base/installations/".concat(installationId, "/inputs?filter={}");
            },
            transformResponse: function (response, meta, arg) { return prepareResponseObject(response.data); },
        }),
    }); },
});
// eslint-disable-next-line import/prefer-default-export
var useGetInputsQuery = extendedApi$8.useGetInputsQuery;

var extendedApi$7 = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getRoles: builder.query({
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            query: function (installationId) { return "/base/installations/".concat(installationId, "/roles"); },
            providesTags: function (result) { return (result
                ? __spreadArray(__spreadArray([], result.map(function (_a) {
                    var id = _a.id;
                    return ({ type: 'Role', id: id });
                }), true), [
                    { type: 'Role', id: 'LIST' },
                ], false) : [{ type: 'Role', id: 'LIST' }]); },
        }),
        addRole: builder.mutation({
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            query: function (_a) {
                var installationId = _a.installationId, role = _a.role, roomIds = _a.roomIds, userId = _a.userId;
                return ({
                    url: "/base/installations/".concat(installationId, "/roles"),
                    method: 'POST',
                    body: prepareRequestPayloadObject({
                        installationId: installationId,
                        role: role,
                        roomIds: roomIds,
                        userId: userId,
                    }),
                });
            },
        }),
        updateRole: builder.mutation({
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            query: function (_a) {
                var roleId = _a.roleId, installationId = _a.installationId, role = _a.role, roomIds = _a.roomIds, userId = _a.userId;
                return ({
                    url: "/base/installations/".concat(installationId, "/roles/").concat(roleId),
                    method: 'PUT',
                    body: prepareRequestPayloadObject({
                        installationId: installationId,
                        role: role,
                        roomIds: roomIds,
                        userId: userId,
                    }),
                });
            },
            invalidatesTags: function (res, err, _a) {
                var roleId = _a.roleId;
                return [{ type: 'Role', id: roleId }];
            },
        }),
        deleteRole: builder.mutation({
            query: function (_a) {
                var roleId = _a.roleId, installationId = _a.installationId;
                return ({
                    url: "/base/installations/".concat(installationId, "/roles/").concat(roleId),
                    method: 'DELETE',
                });
            },
            invalidatesTags: function (res, err, _a) {
                var roleId = _a.roleId;
                return [{ type: 'Role', id: roleId }, { type: 'User', id: 'LIST' }];
            },
        }),
    }); },
});
var useGetRolesQuery = extendedApi$7.useGetRolesQuery, useLazyGetRolesQuery = extendedApi$7.useLazyGetRolesQuery, useAddRoleMutation = extendedApi$7.useAddRoleMutation, useUpdateRoleMutation = extendedApi$7.useUpdateRoleMutation, useDeleteRoleMutation = extendedApi$7.useDeleteRoleMutation;

var extendedApi$6 = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getReports: builder.query({
            query: function (_a) {
                var installationId = _a.installationId, start = _a.start, end = _a.end;
                return ({
                    url: "reports/installations/".concat(installationId, "/energy/summary/export?start=").concat(start, "&end=").concat(end, "&type=txt&download=false"),
                    method: 'GET',
                    responseHandler: function (response) { return response.text(); },
                });
            },
        }),
    }); },
});
var useLazyGetReportsQuery = extendedApi$6.useLazyGetReportsQuery;

var extendedApi$5 = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getUsers: builder.query({
            transformResponse: function (response, meta, arg) { return prepareResponseObject(response.data); },
            query: function (installationId) { return ({
                url: "/base/users?installation_id=".concat(installationId),
                method: 'GET',
            }); },
            providesTags: function (result) { return (result
                ? __spreadArray(__spreadArray([], result.map(function (_a) {
                    var id = _a.id;
                    return ({ type: 'User', id: id });
                }), true), [
                    { type: 'User', id: 'LIST' },
                ], false) : [{ type: 'User', id: 'LIST' }]); },
        }),
        getUser: builder.query({
            transformResponse: function (response, meta, arg) { return prepareResponseObject(response.data); },
            query: function (_a) {
                var email = _a.email;
                return ({
                    url: "/base/users?email=".concat(email),
                    method: 'GET',
                });
            },
        }),
        addUser: builder.mutation({
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            query: function (_a) {
                var email = _a.email, firstName = _a.firstName, lastName = _a.lastName, password = _a.password;
                return ({
                    url: '/base/users',
                    method: 'POST',
                    body: prepareRequestPayloadObject({
                        email: email,
                        firstName: firstName,
                        lastName: lastName,
                        password: password,
                    }),
                });
            },
        }),
        updateUser: builder.mutation({
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            query: function (_a) {
                var id = _a.id, email = _a.email, firstName = _a.firstName, lastName = _a.lastName, password = _a.password;
                return ({
                    url: "/base/users/".concat(id),
                    method: 'PUT',
                    body: prepareRequestPayloadObject({
                        email: email,
                        firstName: firstName,
                        lastName: lastName,
                        password: password,
                    }),
                });
            },
        }),
    }); },
});
var useGetUsersQuery = extendedApi$5.useGetUsersQuery, useLazyGetUsersQuery = extendedApi$5.useLazyGetUsersQuery, useLazyGetUserQuery = extendedApi$5.useLazyGetUserQuery, useAddUserMutation = extendedApi$5.useAddUserMutation, useUpdateUserMutation = extendedApi$5.useUpdateUserMutation;

var extendedApi$4 = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        applications: builder.query({
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            query: function (applicationsData) { return ({
                url: '/authentication/oauth2/applications',
            }); },
            providesTags: function (result) { return (result
                ? __spreadArray(__spreadArray([], result.map(function (_a) {
                    var id = _a.id;
                    return ({ type: 'Application', id: id });
                }), true), [
                    { type: 'Application', id: 'LIST' },
                ], false) : [{ type: 'Application', id: 'LIST' }]); },
        }),
        addApplication: builder.mutation({
            transformResponse: function (response) { return prepareResponseObject(response); },
            query: function (data) { return ({
                url: '/authentication/oauth2/applications',
                method: 'POST',
                body: prepareRequestPayloadObject(data),
            }); },
            invalidatesTags: function () { return [{ type: 'Application', id: 'LIST' }]; },
        }),
        deleteApplication: builder.mutation({
            query: function (id) { return ({
                url: "authentication/oauth2/applications/".concat(id),
                method: 'DELETE',
            }); },
            invalidatesTags: function () { return [{ type: 'Application', id: 'LIST' }]; },
        }),
        applicationGrants: builder.query({
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            query: function (applicationGrantsData) { return ({
                url: '/authentication/oauth2/application-grants',
            }); },
            providesTags: function (result) { return (result
                ? __spreadArray(__spreadArray([], result.map(function (_a) {
                    var id = _a.id;
                    return ({ type: 'ApplicationGrant', id: id });
                }), true), [
                    { type: 'ApplicationGrant', id: 'LIST' },
                ], false) : [{ type: 'ApplicationGrant', id: 'LIST' }]); },
        }),
        deleteApplicationGrant: builder.mutation({
            query: function (id) { return ({
                url: "authentication/oauth2/application-grants/".concat(id),
                method: 'DELETE',
            }); },
            invalidatesTags: function () { return [{ type: 'ApplicationGrant', id: 'LIST' }]; },
        }),
    }); },
});
var useApplicationsQuery = extendedApi$4.useApplicationsQuery, useAddApplicationMutation = extendedApi$4.useAddApplicationMutation, useDeleteApplicationMutation = extendedApi$4.useDeleteApplicationMutation, useApplicationGrantsQuery = extendedApi$4.useApplicationGrantsQuery, useDeleteApplicationGrantMutation = extendedApi$4.useDeleteApplicationGrantMutation;

var extendedApi$3 = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getBackups: builder.query({
            query: function (_a) {
                var installationId = _a.installationId, gatewayId = _a.gatewayId;
                return "/base/installations/".concat(installationId, "/gateways/openmotics/").concat(gatewayId, "/backups");
            },
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            providesTags: function (result) { return (result ? __spreadArray(__spreadArray([], result.map(function (_a) {
                var id = _a.id;
                return ({ type: 'Settings', id: id });
            }), true), ['Settings'], false) : ['Settings']); },
        }),
        setBackupSettings: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, payload = _a.payload;
                return ({
                    url: "/base/installations/".concat(installationId, "/settings/backup"),
                    method: 'POST',
                    body: prepareRequestPayloadObject(payload),
                });
            },
            invalidatesTags: ['Settings'],
        }),
        createBackup: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, gatewayId = _a.gatewayId, payload = _a.payload;
                return ({
                    url: "/base/installations/".concat(installationId, "/gateways/openmotics/").concat(gatewayId, "/backups"),
                    method: 'POST',
                    body: prepareRequestPayloadObject(payload),
                });
            },
            invalidatesTags: ['Settings'],
        }),
        restoreBackup: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, gatewayId = _a.gatewayId, backupId = _a.backupId;
                return ({
                    url: "/base/installations/".concat(installationId, "/gateways/openmotics/").concat(gatewayId, "/backups/").concat(backupId, "/restore"),
                    method: 'POST',
                });
            },
        }),
    }); },
});
var useGetBackupsQuery = extendedApi$3.useGetBackupsQuery, useSetBackupSettingsMutation = extendedApi$3.useSetBackupSettingsMutation, useCreateBackupMutation = extendedApi$3.useCreateBackupMutation, useRestoreBackupMutation = extendedApi$3.useRestoreBackupMutation;

var extendedApi$2 = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getPluginStore: builder.query({
            query: function () { return '/base/pluginstore'; },
            transformResponse: function (response, meta, arg) { return prepareResponseObject(response.data); },
        }),
        getCategories: builder.query({
            query: function () { return '/base/pluginstore/categories'; },
            transformResponse: function (response, meta, arg) { return prepareResponseObject(response.data); },
        }),
        getPlugins: builder.query({
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            query: function (_a) {
                var installationId = _a.installationId, gatewayId = _a.gatewayId;
                return "/base/installations/".concat(installationId, "/gateways/openmotics/").concat(gatewayId, "/plugins");
            },
        }),
        getPlugin: builder.query({
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            query: function (_a) {
                var installationId = _a.installationId, gatewayId = _a.gatewayId, pluginId = _a.pluginId;
                return "/base/installations/".concat(installationId, "/gateways/openmotics/").concat(gatewayId, "/plugins/").concat(pluginId);
            },
        }),
        installPlugin: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, gatewayId = _a.gatewayId, pluginId = _a.pluginId;
                return ({
                    url: "/base/installations/".concat(installationId, "/gateways/openmotics/").concat(gatewayId, "/plugins/").concat(pluginId),
                    method: 'PUT',
                });
            },
            invalidatesTags: function () { return [{ type: 'PluginConfig', id: 'OBJECT' }]; },
        }),
        removePlugin: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, gatewayId = _a.gatewayId, pluginId = _a.pluginId;
                return ({
                    url: "/base/installations/".concat(installationId, "/gateways/openmotics/").concat(gatewayId, "/plugins/").concat(pluginId),
                    method: 'DELETE',
                });
            },
            invalidatesTags: function () { return [{ type: 'PluginConfig', id: 'OBJECT' }]; },
        }),
        startPlugin: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, gatewayId = _a.gatewayId, pluginId = _a.pluginId;
                return ({
                    url: "/base/installations/".concat(installationId, "/gateways/openmotics/").concat(gatewayId, "/plugins/").concat(pluginId, "/start"),
                    method: 'POST',
                });
            },
            invalidatesTags: function () { return [{ type: 'PluginConfig', id: 'OBJECT' }]; },
        }),
        stopPlugin: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, gatewayId = _a.gatewayId, pluginId = _a.pluginId;
                return ({
                    url: "/base/installations/".concat(installationId, "/gateways/openmotics/").concat(gatewayId, "/plugins/").concat(pluginId, "/stop"),
                    method: 'POST',
                });
            },
            invalidatesTags: function () { return [{ type: 'PluginConfig', id: 'OBJECT' }]; },
        }),
        getPluginConfig: builder.query({
            // do not transform this request, just return the config.
            // The form is generated from the backend config and keys and casings need to be respected.
            transformResponse: function (response) { return response.data.config; },
            query: function (_a) {
                var installationId = _a.installationId, gatewayId = _a.gatewayId, pluginId = _a.pluginId;
                return "/base/installations/".concat(installationId, "/gateways/openmotics/").concat(gatewayId, "/plugins/").concat(pluginId, "/config");
            },
            providesTags: function () { return [{ type: 'PluginConfig', id: 'OBJECT' }]; },
        }),
        setPluginConfig: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, gatewayId = _a.gatewayId, pluginId = _a.pluginId, payload = _a.payload;
                return ({
                    url: "/base/installations/".concat(installationId, "/gateways/openmotics/").concat(gatewayId, "/plugins/").concat(pluginId, "/config"),
                    method: 'POST',
                    body: payload,
                });
            },
            invalidatesTags: function () { return [{ type: 'PluginConfig', id: 'OBJECT' }]; },
        }),
        getPluginConfigDescription: builder.query({
            transformResponse: function (response) { return prepareResponseObject(response.data); },
            query: function (_a) {
                var installationId = _a.installationId, gatewayId = _a.gatewayId, pluginId = _a.pluginId;
                return "/base/installations/".concat(installationId, "/gateways/openmotics/").concat(gatewayId, "/plugins/").concat(pluginId, "/config_description");
            },
        }),
    }); },
});
var useGetPluginStoreQuery = extendedApi$2.useGetPluginStoreQuery, useGetCategoriesQuery = extendedApi$2.useGetCategoriesQuery, useGetPluginsQuery = extendedApi$2.useGetPluginsQuery, useGetPluginQuery = extendedApi$2.useGetPluginQuery, useGetPluginConfigQuery = extendedApi$2.useGetPluginConfigQuery, useGetPluginConfigDescriptionQuery = extendedApi$2.useGetPluginConfigDescriptionQuery, useSetPluginConfigMutation = extendedApi$2.useSetPluginConfigMutation, useInstallPluginMutation = extendedApi$2.useInstallPluginMutation, useRemovePluginMutation = extendedApi$2.useRemovePluginMutation, useStartPluginMutation = extendedApi$2.useStartPluginMutation, useStopPluginMutation = extendedApi$2.useStopPluginMutation;

const token = '%[a-f0-9]{2}';
const singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
const multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	const left = components.slice(0, split);
	const right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode$1(input) {
	try {
		return decodeURIComponent(input);
	} catch {
		let tokens = input.match(singleMatcher) || [];

		for (let i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	const replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD',
	};

	let match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch {
			const result = decode$1(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	const entries = Object.keys(replaceMap);

	for (const key of entries) {
		// Replace all decoded components
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

function decodeUriComponent(encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
}

function splitOnFirst(string, separator) {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (string === '' || separator === '') {
		return [];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
}

function includeKeys(object, predicate) {
	const result = {};

	if (Array.isArray(predicate)) {
		for (const key of predicate) {
			const descriptor = Object.getOwnPropertyDescriptor(object, key);
			if (descriptor?.enumerable) {
				Object.defineProperty(result, key, descriptor);
			}
		}
	} else {
		// `Reflect.ownKeys()` is required to retrieve symbol properties
		for (const key of Reflect.ownKeys(object)) {
			const descriptor = Object.getOwnPropertyDescriptor(object, key);
			if (descriptor.enumerable) {
				const value = object[key];
				if (predicate(key, value, object)) {
					Object.defineProperty(result, key, descriptor);
				}
			}
		}
	}

	return result;
}

const isNullOrUndefined = value => value === null || value === undefined;

// eslint-disable-next-line unicorn/prefer-code-point
const strictUriEncode = string => encodeURIComponent(string).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);

const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index': {
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result, [encode(key, options), '[', index, ']'].join(''),
					];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join(''),
				];
			};
		}

		case 'bracket': {
			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result,
						[encode(key, options), '[]'].join(''),
					];
				}

				return [
					...result,
					[encode(key, options), '[]=', encode(value, options)].join(''),
				];
			};
		}

		case 'colon-list-separator': {
			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result,
						[encode(key, options), ':list='].join(''),
					];
				}

				return [
					...result,
					[encode(key, options), ':list=', encode(value, options)].join(''),
				];
			};
		}

		case 'comma':
		case 'separator':
		case 'bracket-separator': {
			const keyValueSep = options.arrayFormat === 'bracket-separator'
				? '[]='
				: '=';

			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				// Translate null to an empty string so that it doesn't serialize as 'null'
				value = value === null ? '' : value;

				if (result.length === 0) {
					return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};
		}

		default: {
			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result,
						encode(key, options),
					];
				}

				return [
					...result,
					[encode(key, options), '=', encode(value, options)].join(''),
				];
			};
		}
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index': {
			return (key, value, accumulator) => {
				result = /\[(\d*)]$/.exec(key);

				key = key.replace(/\[\d*]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};
		}

		case 'bracket': {
			return (key, value, accumulator) => {
				result = /(\[])$/.exec(key);
				key = key.replace(/\[]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [...accumulator[key], value];
			};
		}

		case 'colon-list-separator': {
			return (key, value, accumulator) => {
				result = /(:list)$/.exec(key);
				key = key.replace(/:list$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [...accumulator[key], value];
			};
		}

		case 'comma':
		case 'separator': {
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : (value === null ? value : decode(value, options));
				accumulator[key] = newValue;
			};
		}

		case 'bracket-separator': {
			return (key, value, accumulator) => {
				const isArray = /(\[])$/.test(key);
				key = key.replace(/\[]$/, '');

				if (!isArray) {
					accumulator[key] = value ? decode(value, options) : value;
					return;
				}

				const arrayValue = value === null
					? []
					: value.split(options.arrayFormatSeparator).map(item => decode(item, options));

				if (accumulator[key] === undefined) {
					accumulator[key] = arrayValue;
					return;
				}

				accumulator[key] = [...accumulator[key], ...arrayValue];
			};
		}

		default: {
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [...[accumulator[key]].flat(), value];
			};
		}
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return decodeUriComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parse(query, options) {
	options = {
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false,
		...options,
	};

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const returnValue = Object.create(null);

	if (typeof query !== 'string') {
		return returnValue;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return returnValue;
	}

	for (const parameter of query.split('&')) {
		if (parameter === '') {
			continue;
		}

		const parameter_ = options.decode ? parameter.replace(/\+/g, ' ') : parameter;

		let [key, value] = splitOnFirst(parameter_, '=');

		if (key === undefined) {
			key = parameter_;
		}

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : (['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode(value, options));
		formatter(decode(key, options), value, returnValue);
	}

	for (const [key, value] of Object.entries(returnValue)) {
		if (typeof value === 'object' && value !== null) {
			for (const [key2, value2] of Object.entries(value)) {
				value[key2] = parseValue(value2, options);
			}
		} else {
			returnValue[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return returnValue;
	}

	// TODO: Remove the use of `reduce`.
	// eslint-disable-next-line unicorn/no-array-reduce
	return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key) => {
		const value = returnValue[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

function stringify(object, options) {
	if (!object) {
		return '';
	}

	options = {encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',', ...options};

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key]))
		|| (options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const [key, value] of Object.entries(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = value;
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
				return encode(key, options) + '[]';
			}

			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
}

function parseUrl(url, options) {
	options = {
		decode: true,
		...options,
	};

	let [url_, hash] = splitOnFirst(url, '#');

	if (url_ === undefined) {
		url_ = url;
	}

	return {
		url: url_?.split('?')?.[0] ?? '',
		query: parse(extract(url), options),
		...(options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}),
	};
}

function stringifyUrl(object, options) {
	options = {
		encode: true,
		strict: true,
		[encodeFragmentIdentifier]: true,
		...options,
	};

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = extract(object.url);

	const query = {
		...parse(queryFromUrl, {sort: false}),
		...object.query,
	};

	let queryString = stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		const urlObjectForFragmentEncode = new URL(url);
		urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
		hash = options[encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
	}

	return `${url}${queryString}${hash}`;
}

function pick(input, filter, options) {
	options = {
		parseFragmentIdentifier: true,
		[encodeFragmentIdentifier]: false,
		...options,
	};

	const {url, query, fragmentIdentifier} = parseUrl(input, options);

	return stringifyUrl({
		url,
		query: includeKeys(query, filter),
		fragmentIdentifier,
	}, options);
}

function exclude(input, filter, options) {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return pick(input, exclusionFilter, options);
}

var queryString = /*#__PURE__*/Object.freeze({
    __proto__: null,
    extract: extract,
    parse: parse,
    stringify: stringify,
    parseUrl: parseUrl,
    stringifyUrl: stringifyUrl,
    pick: pick,
    exclude: exclude
});

var extendedApi$1 = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getInsights: builder.query({
            query: function (_a) {
                var installationId = _a.installationId, timeInterval = _a.timeInterval;
                var query = queryString.stringify(timeInterval !== null && timeInterval !== void 0 ? timeInterval : {});
                return "/base/installations/".concat(installationId, "/insights").concat(query ? "?".concat(query) : '');
            },
            transformResponse: function (response) { return prepareResponseObject(response); },
        }),
        getInsight: builder.query({
            query: function (_a) {
                var installationId = _a.installationId, id = _a.id;
                return "/base/installations/".concat(installationId, "/insights/").concat(id);
            },
            transformResponse: function (response) { return prepareResponseObject(response.data); },
        }),
        getInsightStat: builder.query({
            query: function (_a) {
                var installationId = _a.installationId, id = _a.id, params = __rest(_a, ["installationId", "id"]);
                return "/base/installations/".concat(installationId, "/insights/").concat(id, "/stat").concat(queryString.stringify(params) ? "?".concat(queryString.stringify(params)) : '');
            },
            transformResponse: prepareResponseObject,
        }),
        getInsightCounter: builder.query({
            query: function (_a) {
                var installationId = _a.installationId, id = _a.id, params = __rest(_a, ["installationId", "id"]);
                return "/base/installations/".concat(installationId, "/insights/").concat(id, "/counter").concat(queryString.stringify(params) ? "?".concat(queryString.stringify(params)) : '');
            },
            transformResponse: prepareResponseObject,
        }),
        getInsightGauge: builder.query({
            query: function (_a) {
                var installationId = _a.installationId, id = _a.id, params = __rest(_a, ["installationId", "id"]);
                return "/base/installations/".concat(installationId, "/insights/").concat(id, "/gauge").concat(queryString.stringify(params) ? "?".concat(queryString.stringify(params)) : '');
            },
            transformResponse: prepareResponseObject,
        }),
        exportInsight: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, id = _a.id, insightType = _a.insightType, params = __rest(_a, ["installationId", "id", "insightType"]);
                return ({
                    url: "/base/installations/".concat(installationId, "/insights/").concat(id, "/").concat(insightType).concat(queryString.stringify(params) ? "?".concat(queryString.stringify(params)) : ''),
                    method: 'GET',
                    responseHandler: function (response) { return __awaiter(void 0, void 0, void 0, function () { var _a, _b, _c, _d, _e; return __generator(this, function (_f) {
                        switch (_f.label) {
                            case 0:
                                _b = (_a = window.location).assign;
                                _d = (_c = window.URL).createObjectURL;
                                _e = Blob.bind;
                                return [4 /*yield*/, response.blob()];
                            case 1: return [2 /*return*/, _b.apply(_a, [_d.apply(_c, [new (_e.apply(Blob, [void 0, [_f.sent()], { type: 'text/csv' }]))()])])];
                        }
                    }); }); },
                });
            },
        }),
        turnGatewayRealtimeModeOn: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId;
                return ({
                    url: "/base/installations/".concat(installationId, "/insights/realtime"),
                    method: 'POST',
                });
            },
        }),
    }); },
});
var useGetInsightsQuery = extendedApi$1.useGetInsightsQuery, useGetInsightQuery = extendedApi$1.useGetInsightQuery, useGetInsightStatQuery = extendedApi$1.useGetInsightStatQuery, useGetInsightCounterQuery = extendedApi$1.useGetInsightCounterQuery, useGetInsightGaugeQuery = extendedApi$1.useGetInsightGaugeQuery, useLazyGetInsightCounterQuery = extendedApi$1.useLazyGetInsightCounterQuery, useLazyGetInsightGaugeQuery = extendedApi$1.useLazyGetInsightGaugeQuery, useExportInsightMutation = extendedApi$1.useExportInsightMutation, useLazyGetInsightStatQuery = extendedApi$1.useLazyGetInsightStatQuery, useTurnGatewayRealtimeModeOnMutation = extendedApi$1.useTurnGatewayRealtimeModeOnMutation;

var extendedApi = emptyOpenmoticsApi.injectEndpoints({
    endpoints: function (builder) { return ({
        getEnergyTariffs: builder.query({
            query: function (_a) {
                var installationId = _a.installationId;
                return "/base/installations/".concat(installationId, "/settings/tariffs");
            },
            transformResponse: function (response, meta, arg) { return prepareResponseObject(response.data); },
            providesTags: function (result) { return [{ type: 'EnergyTariffs', id: 'Object' }]; },
        }),
        setEnergyTariffs: builder.mutation({
            query: function (_a) {
                var installationId = _a.installationId, tariffs = _a.tariffs;
                return ({
                    url: "/base/installations/".concat(installationId, "/settings/tariffs"),
                    method: 'PUT',
                    body: {
                        electricity_consumption_tariff: tariffs.electricityConsumptionTariff,
                        electricity_injection_tariff: tariffs.electricityInjectionTariff,
                        gas_consumption_tariff: tariffs.gasConsumptionTariff,
                        water_consumption_tariff: tariffs.waterConsumptionTariff,
                        heat_consumption_tariff: tariffs.heatConsumptionTariff,
                    },
                });
            },
            transformResponse: function (response, meta, arg) { return prepareResponseObject(response.data); },
            invalidatesTags: function () { return [{ type: 'EnergyTariffs', id: 'Object' }]; },
        }),
    }); },
});
var useGetEnergyTariffsQuery = extendedApi.useGetEnergyTariffsQuery, useSetEnergyTariffsMutation = extendedApi.useSetEnergyTariffsMutation;

var _a;
var initialState = {
    realtimeData: {},
};
var realtimeSlice = toolkit.createSlice({
    name: 'realtime',
    initialState: initialState,
    reducers: {
        setRealtimeEvent: function (state, action) {
            var _a;
            state.realtimeData = __assign(__assign({}, state.realtimeData), (_a = {}, _a[action.payload.insight] = __assign({}, action.payload), _a));
        },
        resetRealtimeData: function (state) {
            state.realtimeData = initialState.realtimeData;
        },
    },
});
var selectRealtimeData = function (state) { return state.realtime.realtimeData; };
var setRealtimeEvent = (_a = realtimeSlice.actions, _a.setRealtimeEvent), resetRealtimeData = _a.resetRealtimeData;
var realtimeReducer = realtimeSlice.reducer;

var getRealtimeWebsocket = function () {
    var websocket = null;
    var connectRealtimeWebsocket = function (installationId, onMessage) { return __awaiter(void 0, void 0, void 0, function () {
        var url, options;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (websocket) {
                        websocket.close(); // Close the socket, because there is no way unsubscribe from the previous installation.
                        websocket = null;
                    }
                    if (!!websocket) return [3 /*break*/, 2];
                    url = "".concat(getBaseUrl(), "/api/v1.1/ws/events");
                    options = {
                        onError: function (e) {
                            console.warn(e);
                            if (websocket && websocket.installationIds) {
                                websocket.close();
                            }
                        },
                        onMessage: [onMessage],
                        onClose: function () {
                            console.log('Websocket closed');
                            websocket = null;
                        },
                    };
                    websocket = new Websocket(url, options, [SocketDataType.InsightRealtime]);
                    websocket.installationIds = [installationId];
                    return [4 /*yield*/, websocket.connect([installationId])];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return {
        connectRealtimeWebsocket: connectRealtimeWebsocket,
        closeRealtimeWebsocket: function () { if (websocket) {
            websocket.close();
        } },
    };
};

exports.capitalizeFirstLetter = capitalizeFirstLetter;
exports.configuration = configuration;
exports.emptyOpenmoticsApi = emptyOpenmoticsApi;
exports.getBaseUrl = getBaseUrl;
exports.getRealtimeWebsocket = getRealtimeWebsocket;
exports.getToken = getToken;
exports.prepareRequestPayloadObject = prepareRequestPayloadObject;
exports.prepareResponseObject = prepareResponseObject;
exports.realtimeReducer = realtimeReducer;
exports.resetRealtimeData = resetRealtimeData;
exports.selectRealtimeData = selectRealtimeData;
exports.setApiConfig = setApiConfig;
exports.setRealtimeEvent = setRealtimeEvent;
exports.useAddApplicationMutation = useAddApplicationMutation;
exports.useAddFloorMutation = useAddFloorMutation;
exports.useAddInstallationMutation = useAddInstallationMutation;
exports.useAddRoleMutation = useAddRoleMutation;
exports.useAddRoomMutation = useAddRoomMutation;
exports.useAddUserMutation = useAddUserMutation;
exports.useAllControls = useAllControls;
exports.useApplicationGrantsQuery = useApplicationGrantsQuery;
exports.useApplicationsQuery = useApplicationsQuery;
exports.useBoostVentilationUnitMutation = useBoostVentilationUnitMutation;
exports.useCallbackOnScreenResize = useCallbackOnScreenResize;
exports.useCreateBackupMutation = useCreateBackupMutation;
exports.useDeleteApplicationGrantMutation = useDeleteApplicationGrantMutation;
exports.useDeleteApplicationMutation = useDeleteApplicationMutation;
exports.useDeleteDashboardControlsMutation = useDeleteDashboardControlsMutation;
exports.useDeleteEventRuleMutation = useDeleteEventRuleMutation;
exports.useDeleteFloorImageMutation = useDeleteFloorImageMutation;
exports.useDeleteFloorMutation = useDeleteFloorMutation;
exports.useDeleteRoleMutation = useDeleteRoleMutation;
exports.useDeleteRoomImageMutation = useDeleteRoomImageMutation;
exports.useExportInsightMutation = useExportInsightMutation;
exports.useGetBackupsQuery = useGetBackupsQuery;
exports.useGetCategoriesQuery = useGetCategoriesQuery;
exports.useGetCurrentUserInfoQuery = useGetCurrentUserInfoQuery;
exports.useGetCurrentUserQuery = useGetCurrentUserQuery;
exports.useGetDashboardControlsQuery = useGetDashboardControlsQuery;
exports.useGetEnergyTariffsQuery = useGetEnergyTariffsQuery;
exports.useGetEventRulesQuery = useGetEventRulesQuery;
exports.useGetFloorsQuery = useGetFloorsQuery;
exports.useGetGatewaysQuery = useGetGatewaysQuery;
exports.useGetHotWaterListQuery = useGetHotWaterListQuery;
exports.useGetInputsQuery = useGetInputsQuery;
exports.useGetInsightCounterQuery = useGetInsightCounterQuery;
exports.useGetInsightGaugeQuery = useGetInsightGaugeQuery;
exports.useGetInsightQuery = useGetInsightQuery;
exports.useGetInsightStatQuery = useGetInsightStatQuery;
exports.useGetInsightsQuery = useGetInsightsQuery;
exports.useGetInstallationQuery = useGetInstallationQuery;
exports.useGetInstallationSettingsQuery = useGetInstallationSettingsQuery;
exports.useGetInstallationsQuery = useGetInstallationsQuery;
exports.useGetLabelHistoricalQuery = useGetLabelHistoricalQuery;
exports.useGetLabelQuery = useGetLabelQuery;
exports.useGetLabelsQuery = useGetLabelsQuery;
exports.useGetNotificationsQuery = useGetNotificationsQuery;
exports.useGetOpenmoticsGatewaysQuery = useGetOpenmoticsGatewaysQuery;
exports.useGetOutputQuery = useGetOutputQuery;
exports.useGetOutputsQuery = useGetOutputsQuery;
exports.useGetPluginConfigDescriptionQuery = useGetPluginConfigDescriptionQuery;
exports.useGetPluginConfigQuery = useGetPluginConfigQuery;
exports.useGetPluginQuery = useGetPluginQuery;
exports.useGetPluginStoreQuery = useGetPluginStoreQuery;
exports.useGetPluginsQuery = useGetPluginsQuery;
exports.useGetResetGatewayConfirmationCodeQuery = useGetResetGatewayConfirmationCodeQuery;
exports.useGetRolesQuery = useGetRolesQuery;
exports.useGetRoomQuery = useGetRoomQuery;
exports.useGetRoomsQuery = useGetRoomsQuery;
exports.useGetScenesQuery = useGetScenesQuery;
exports.useGetSensorsQuery = useGetSensorsQuery;
exports.useGetShuttersQuery = useGetShuttersQuery;
exports.useGetThermostatGroupsQuery = useGetThermostatGroupsQuery;
exports.useGetThermostatUnitQuery = useGetThermostatUnitQuery;
exports.useGetThermostatUnitScheduleQuery = useGetThermostatUnitScheduleQuery;
exports.useGetThermostatUnitsQuery = useGetThermostatUnitsQuery;
exports.useGetUsersQuery = useGetUsersQuery;
exports.useGetVentilationUnitsQuery = useGetVentilationUnitsQuery;
exports.useInitResetPasswordFlowMutation = useInitResetPasswordFlowMutation;
exports.useInstallPluginMutation = useInstallPluginMutation;
exports.useLazyGetCsvMetricsQuery = useLazyGetCsvMetricsQuery;
exports.useLazyGetInsightCounterQuery = useLazyGetInsightCounterQuery;
exports.useLazyGetInsightGaugeQuery = useLazyGetInsightGaugeQuery;
exports.useLazyGetInsightStatQuery = useLazyGetInsightStatQuery;
exports.useLazyGetReportsQuery = useLazyGetReportsQuery;
exports.useLazyGetRolesQuery = useLazyGetRolesQuery;
exports.useLazyGetUserQuery = useLazyGetUserQuery;
exports.useLazyGetUsersQuery = useLazyGetUsersQuery;
exports.useLoginMutation = useLoginMutation;
exports.useRegisterMutation = useRegisterMutation;
exports.useRemovePluginMutation = useRemovePluginMutation;
exports.useRemoveRoomMutation = useRemoveRoomMutation;
exports.useResetGatewayMutation = useResetGatewayMutation;
exports.useResetPasswordMutation = useResetPasswordMutation;
exports.useRestoreBackupMutation = useRestoreBackupMutation;
exports.useSaveDashboardControlsMutation = useSaveDashboardControlsMutation;
exports.useSearchInstallationsQuery = useSearchInstallationsQuery;
exports.useSetBackupSettingsMutation = useSetBackupSettingsMutation;
exports.useSetCurrentUserInfoMutation = useSetCurrentUserInfoMutation;
exports.useSetCurrentUserTfaMutation = useSetCurrentUserTfaMutation;
exports.useSetEnergyTariffsMutation = useSetEnergyTariffsMutation;
exports.useSetEventRuleMutation = useSetEventRuleMutation;
exports.useSetGlobalModeMutation = useSetGlobalModeMutation;
exports.useSetGlobalPresetMutation = useSetGlobalPresetMutation;
exports.useSetGlobalStateMutation = useSetGlobalStateMutation;
exports.useSetGroupModeMutation = useSetGroupModeMutation;
exports.useSetGroupPresetMutation = useSetGroupPresetMutation;
exports.useSetGroupStateMutation = useSetGroupStateMutation;
exports.useSetHotWaterSetpointMutation = useSetHotWaterSetpointMutation;
exports.useSetHotWaterStateMutation = useSetHotWaterStateMutation;
exports.useSetOutputLocationMutation = useSetOutputLocationMutation;
exports.useSetPluginConfigMutation = useSetPluginConfigMutation;
exports.useSetReadNotificationsMutation = useSetReadNotificationsMutation;
exports.useSetShutterLocationMutation = useSetShutterLocationMutation;
exports.useSetShutterMotionMutation = useSetShutterMotionMutation;
exports.useSetShutterPositionMutation = useSetShutterPositionMutation;
exports.useSetShutterRotationMutation = useSetShutterRotationMutation;
exports.useSetThermostatUnitScheduleMutation = useSetThermostatUnitScheduleMutation;
exports.useSetUnitEarlyStartsMutation = useSetUnitEarlyStartsMutation;
exports.useSetUnitPresetConfigMutation = useSetUnitPresetConfigMutation;
exports.useSetUnitPresetMutation = useSetUnitPresetMutation;
exports.useSetUnitPresetNewMutation = useSetUnitPresetNewMutation;
exports.useSetUnitSetpointMutation = useSetUnitSetpointMutation;
exports.useSetUnitStateMutation = useSetUnitStateMutation;
exports.useSetVentilationUnitLevelMutation = useSetVentilationUnitLevelMutation;
exports.useSetVentilationUnitModeMutation = useSetVentilationUnitModeMutation;
exports.useStartPluginMutation = useStartPluginMutation;
exports.useStopPluginMutation = useStopPluginMutation;
exports.useTriggerGroupActionMutation = useTriggerGroupActionMutation;
exports.useTurnGatewayRealtimeModeOnMutation = useTurnGatewayRealtimeModeOnMutation;
exports.useTurnOffOutputsMutation = useTurnOffOutputsMutation;
exports.useUpdateEventRuleMutation = useUpdateEventRuleMutation;
exports.useUpdateFloorMutation = useUpdateFloorMutation;
exports.useUpdateGatewayNameMutation = useUpdateGatewayNameMutation;
exports.useUpdateInstallationMutation = useUpdateInstallationMutation;
exports.useUpdateLightMutation = useUpdateLightMutation;
exports.useUpdateRoleMutation = useUpdateRoleMutation;
exports.useUpdateRoomMutation = useUpdateRoomMutation;
exports.useUpdateUserMutation = useUpdateUserMutation;
exports.useUploadFloorImageMutation = useUploadFloorImageMutation;
exports.useUploadRoomImageMutation = useUploadRoomImageMutation;
//# sourceMappingURL=index.js.map
